import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Dimension: { input: any; output: any; }
  HexColor: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Quality: { input: any; output: any; }
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type Accordion = Entry & _Node & {
  __typename?: 'Accordion';
  _id: Scalars['ID']['output'];
  accordionItemsCollection?: Maybe<AccordionAccordionItemsCollection>;
  backgroundImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<AccordionDescription>;
  image?: Maybe<Asset>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AccordionLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionAccordionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionAccordionItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordion) */
export type AccordionVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionAccordionItemsCollection = {
  __typename?: 'AccordionAccordionItemsCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum AccordionAccordionItemsCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  ItemTextAsc = 'itemText_ASC',
  ItemTextDesc = 'itemText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AccordionCollection = {
  __typename?: 'AccordionCollection';
  items: Array<Maybe<Accordion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionDescription = {
  __typename?: 'AccordionDescription';
  json: Scalars['JSON']['output'];
  links: AccordionDescriptionLinks;
};

export type AccordionDescriptionAssets = {
  __typename?: 'AccordionDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AccordionDescriptionEntries = {
  __typename?: 'AccordionDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AccordionDescriptionLinks = {
  __typename?: 'AccordionDescriptionLinks';
  assets: AccordionDescriptionAssets;
  entries: AccordionDescriptionEntries;
  resources: AccordionDescriptionResources;
};

export type AccordionDescriptionResources = {
  __typename?: 'AccordionDescriptionResources';
  block: Array<AccordionDescriptionResourcesBlock>;
  hyperlink: Array<AccordionDescriptionResourcesHyperlink>;
  inline: Array<AccordionDescriptionResourcesInline>;
};

export type AccordionDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'AccordionDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type AccordionDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'AccordionDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type AccordionDescriptionResourcesInline = ResourceLink & {
  __typename?: 'AccordionDescriptionResourcesInline';
  sys: ResourceSys;
};

export type AccordionFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionFilter>>>;
  accordionItems?: InputMaybe<CfAccordionItemNestedFilter>;
  accordionItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItem = Entry & _Node & {
  __typename?: 'AccordionItem';
  _id: Scalars['ID']['output'];
  additionalItemText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Asset>;
  internalName?: Maybe<Scalars['String']['output']>;
  itemDescription?: Maybe<AccordionItemItemDescription>;
  itemText?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AccordionItemLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemAdditionalItemTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemItemDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemItemTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/accordionItem) */
export type AccordionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccordionItemCollection = {
  __typename?: 'AccordionItemCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionItemFilter>>>;
  additionalItemText?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_contains?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  additionalItemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalItemText_not?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemDescription_contains?: InputMaybe<Scalars['String']['input']>;
  itemDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  itemText_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText_not?: InputMaybe<Scalars['String']['input']>;
  itemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionItemItemDescription = {
  __typename?: 'AccordionItemItemDescription';
  json: Scalars['JSON']['output'];
  links: AccordionItemItemDescriptionLinks;
};

export type AccordionItemItemDescriptionAssets = {
  __typename?: 'AccordionItemItemDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AccordionItemItemDescriptionEntries = {
  __typename?: 'AccordionItemItemDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AccordionItemItemDescriptionLinks = {
  __typename?: 'AccordionItemItemDescriptionLinks';
  assets: AccordionItemItemDescriptionAssets;
  entries: AccordionItemItemDescriptionEntries;
  resources: AccordionItemItemDescriptionResources;
};

export type AccordionItemItemDescriptionResources = {
  __typename?: 'AccordionItemItemDescriptionResources';
  block: Array<AccordionItemItemDescriptionResourcesBlock>;
  hyperlink: Array<AccordionItemItemDescriptionResourcesHyperlink>;
  inline: Array<AccordionItemItemDescriptionResourcesInline>;
};

export type AccordionItemItemDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'AccordionItemItemDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type AccordionItemItemDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'AccordionItemItemDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type AccordionItemItemDescriptionResourcesInline = ResourceLink & {
  __typename?: 'AccordionItemItemDescriptionResourcesInline';
  sys: ResourceSys;
};

export type AccordionItemLinkingCollections = {
  __typename?: 'AccordionItemLinkingCollections';
  accordionCollection?: Maybe<AccordionCollection>;
  entryCollection?: Maybe<EntryCollection>;
  tabCollection?: Maybe<TabCollection>;
};


export type AccordionItemLinkingCollectionsAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemLinkingCollectionsAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AccordionItemLinkingCollectionsAccordionCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum AccordionItemLinkingCollectionsTabCollectionOrder {
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TabTitleAsc = 'tabTitle_ASC',
  TabTitleDesc = 'tabTitle_DESC'
}

export enum AccordionItemOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  ItemTextAsc = 'itemText_ASC',
  ItemTextDesc = 'itemText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AccordionLinkingCollections = {
  __typename?: 'AccordionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AccordionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AccordionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummit = Entry & _Node & {
  __typename?: 'AdobeSummit';
  _id: Scalars['ID']['output'];
  banner?: Maybe<Hero>;
  cardCollection?: Maybe<AdobeSummitCardCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<AdobeSummitDescription>;
  linkedFrom?: Maybe<AdobeSummitLinkingCollections>;
  primaryButton?: Maybe<Button>;
  seoFields?: Maybe<SeoFields>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdobeSummitCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitPrimaryButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitSeoFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SeoFieldsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/adobeSummit) */
export type AdobeSummitTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AdobeSummitCardCollection = {
  __typename?: 'AdobeSummitCardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum AdobeSummitCardCollectionOrder {
  CardEyebrowTextAsc = 'cardEyebrowText_ASC',
  CardEyebrowTextDesc = 'cardEyebrowText_DESC',
  CardLinkTextAsc = 'cardLinkText_ASC',
  CardLinkTextDesc = 'cardLinkText_DESC',
  CardLinkAsc = 'cardLink_ASC',
  CardLinkDesc = 'cardLink_DESC',
  CardTitleAsc = 'cardTitle_ASC',
  CardTitleDesc = 'cardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AdobeSummitCollection = {
  __typename?: 'AdobeSummitCollection';
  items: Array<Maybe<AdobeSummit>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdobeSummitDescription = {
  __typename?: 'AdobeSummitDescription';
  json: Scalars['JSON']['output'];
  links: AdobeSummitDescriptionLinks;
};

export type AdobeSummitDescriptionAssets = {
  __typename?: 'AdobeSummitDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AdobeSummitDescriptionEntries = {
  __typename?: 'AdobeSummitDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AdobeSummitDescriptionLinks = {
  __typename?: 'AdobeSummitDescriptionLinks';
  assets: AdobeSummitDescriptionAssets;
  entries: AdobeSummitDescriptionEntries;
  resources: AdobeSummitDescriptionResources;
};

export type AdobeSummitDescriptionResources = {
  __typename?: 'AdobeSummitDescriptionResources';
  block: Array<AdobeSummitDescriptionResourcesBlock>;
  hyperlink: Array<AdobeSummitDescriptionResourcesHyperlink>;
  inline: Array<AdobeSummitDescriptionResourcesInline>;
};

export type AdobeSummitDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'AdobeSummitDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type AdobeSummitDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'AdobeSummitDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type AdobeSummitDescriptionResourcesInline = ResourceLink & {
  __typename?: 'AdobeSummitDescriptionResourcesInline';
  sys: ResourceSys;
};

export type AdobeSummitFilter = {
  AND?: InputMaybe<Array<InputMaybe<AdobeSummitFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AdobeSummitFilter>>>;
  banner?: InputMaybe<CfHeroNestedFilter>;
  banner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card?: InputMaybe<CfCardNestedFilter>;
  cardCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  primaryButton?: InputMaybe<CfButtonNestedFilter>;
  primaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoFields?: InputMaybe<CfSeoFieldsNestedFilter>;
  seoFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdobeSummitLinkingCollections = {
  __typename?: 'AdobeSummitLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AdobeSummitLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AdobeSummitOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/aiContent) */
export type AiContent = Entry & _Node & {
  __typename?: 'AiContent';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyeBrowText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AiContentLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/aiContent) */
export type AiContentDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/aiContent) */
export type AiContentEyeBrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/aiContent) */
export type AiContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/aiContent) */
export type AiContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AiContentCollection = {
  __typename?: 'AiContentCollection';
  items: Array<Maybe<AiContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AiContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<AiContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AiContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyeBrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiContentLinkingCollections = {
  __typename?: 'AiContentLinkingCollections';
  articleCollection?: Maybe<ArticleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AiContentLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AiContentLinkingCollectionsArticleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AiContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AiContentLinkingCollectionsArticleCollectionOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AiContentOrder {
  EyeBrowTextAsc = 'eyeBrowText_ASC',
  EyeBrowTextDesc = 'eyeBrowText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type Article = Entry & _Node & {
  __typename?: 'Article';
  _id: Scalars['ID']['output'];
  aiContent?: Maybe<AiContent>;
  articleLink?: Maybe<Link>;
  articleType?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Author>;
  authors?: Maybe<Scalars['String']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ArticleDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkList?: Maybe<ListOfLinks>;
  linkedFrom?: Maybe<ArticleLinkingCollections>;
  mainImage?: Maybe<Asset>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  socialMediaLinksCollection?: Maybe<ArticleSocialMediaLinksCollection>;
  subDescription?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnailImage?: Maybe<Asset>;
  title?: Maybe<Scalars['String']['output']>;
  videoFile?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleAiContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleArticleLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleArticleTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleAuthorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleAuthorsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleLinkListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListOfLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleMainImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticlePublicationDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleSocialMediaLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleSocialMediaLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleSubDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleThumbnailImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/article) */
export type ArticleVideoFileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCollection = {
  __typename?: 'ArticleCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ArticleDescription = {
  __typename?: 'ArticleDescription';
  json: Scalars['JSON']['output'];
  links: ArticleDescriptionLinks;
};

export type ArticleDescriptionAssets = {
  __typename?: 'ArticleDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ArticleDescriptionEntries = {
  __typename?: 'ArticleDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ArticleDescriptionLinks = {
  __typename?: 'ArticleDescriptionLinks';
  assets: ArticleDescriptionAssets;
  entries: ArticleDescriptionEntries;
  resources: ArticleDescriptionResources;
};

export type ArticleDescriptionResources = {
  __typename?: 'ArticleDescriptionResources';
  block: Array<ArticleDescriptionResourcesBlock>;
  hyperlink: Array<ArticleDescriptionResourcesHyperlink>;
  inline: Array<ArticleDescriptionResourcesInline>;
};

export type ArticleDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ArticleDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ArticleDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ArticleDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ArticleDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ArticleDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ArticleFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  aiContent?: InputMaybe<CfAiContentNestedFilter>;
  aiContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleLink?: InputMaybe<CfLinkNestedFilter>;
  articleLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleType?: InputMaybe<Scalars['String']['input']>;
  articleType_contains?: InputMaybe<Scalars['String']['input']>;
  articleType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleType_not?: InputMaybe<Scalars['String']['input']>;
  articleType_not_contains?: InputMaybe<Scalars['String']['input']>;
  articleType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author?: InputMaybe<CfAuthorNestedFilter>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authors?: InputMaybe<Scalars['String']['input']>;
  authors_contains?: InputMaybe<Scalars['String']['input']>;
  authors_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authors_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authors_not?: InputMaybe<Scalars['String']['input']>;
  authors_not_contains?: InputMaybe<Scalars['String']['input']>;
  authors_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  colour_contains?: InputMaybe<Scalars['String']['input']>;
  colour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not?: InputMaybe<Scalars['String']['input']>;
  colour_not_contains?: InputMaybe<Scalars['String']['input']>;
  colour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkList?: InputMaybe<CfListOfLinksNestedFilter>;
  linkList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publicationDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publicationDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaLinks?: InputMaybe<CfLinkNestedFilter>;
  socialMediaLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription?: InputMaybe<Scalars['String']['input']>;
  subDescription_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subDescription_not?: InputMaybe<Scalars['String']['input']>;
  subDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  thumbnailImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoFile_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleLinkingCollections = {
  __typename?: 'ArticleLinkingCollections';
  articleListCollection?: Maybe<ArticleListCollection>;
  blogSectionCollection?: Maybe<BlogSectionCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageBlogDetailPageCollection?: Maybe<PageBlogDetailPageCollection>;
};


export type ArticleLinkingCollectionsArticleListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsArticleListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleLinkingCollectionsBlogSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsBlogSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleLinkingCollectionsPageBlogDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsPageBlogDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ArticleLinkingCollectionsArticleListCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsBlogSectionCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsPageBlogDetailPageCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleList = Entry & _Node & {
  __typename?: 'ArticleList';
  _id: Scalars['ID']['output'];
  articlesCollection?: Maybe<ArticleListArticlesCollection>;
  button?: Maybe<Button>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ArticleListDescription>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ArticleListLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleListArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/articleList) */
export type ArticleListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleListArticlesCollection = {
  __typename?: 'ArticleListArticlesCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ArticleListArticlesCollectionOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ArticleListCollection = {
  __typename?: 'ArticleListCollection';
  items: Array<Maybe<ArticleList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ArticleListDescription = {
  __typename?: 'ArticleListDescription';
  json: Scalars['JSON']['output'];
  links: ArticleListDescriptionLinks;
};

export type ArticleListDescriptionAssets = {
  __typename?: 'ArticleListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ArticleListDescriptionEntries = {
  __typename?: 'ArticleListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ArticleListDescriptionLinks = {
  __typename?: 'ArticleListDescriptionLinks';
  assets: ArticleListDescriptionAssets;
  entries: ArticleListDescriptionEntries;
  resources: ArticleListDescriptionResources;
};

export type ArticleListDescriptionResources = {
  __typename?: 'ArticleListDescriptionResources';
  block: Array<ArticleListDescriptionResourcesBlock>;
  hyperlink: Array<ArticleListDescriptionResourcesHyperlink>;
  inline: Array<ArticleListDescriptionResourcesInline>;
};

export type ArticleListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ArticleListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ArticleListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ArticleListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ArticleListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ArticleListDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ArticleListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleListFilter>>>;
  articles?: InputMaybe<CfArticleNestedFilter>;
  articlesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  button?: InputMaybe<CfButtonNestedFilter>;
  button_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleListLinkingCollections = {
  __typename?: 'ArticleListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ArticleListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ArticleListOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ArticleSocialMediaLinksCollection = {
  __typename?: 'ArticleSocialMediaLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ArticleSocialMediaLinksCollectionOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  accordionCollection?: Maybe<AccordionCollection>;
  accordionItemCollection?: Maybe<AccordionItemCollection>;
  articleCollection?: Maybe<ArticleCollection>;
  authorCollection?: Maybe<AuthorCollection>;
  bannerCollection?: Maybe<BannerCollection>;
  blogSectionCollection?: Maybe<BlogSectionCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  cardCollection?: Maybe<CardCollection>;
  contentTileCollection?: Maybe<ContentTileCollection>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroWithCardsCollection?: Maybe<HeroWithCardsCollection>;
  imageAndTextCollection?: Maybe<ImageAndTextCollection>;
  linkCollection?: Maybe<LinkCollection>;
  logoCollection?: Maybe<LogoCollection>;
  menuItemCollection?: Maybe<MenuItemCollection>;
  profileCollection?: Maybe<ProfileCollection>;
  securityTextCollection?: Maybe<SecurityTextCollection>;
  seoFieldsCollection?: Maybe<SeoFieldsCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabListCollection?: Maybe<TabListCollection>;
  verticalTabCollection?: Maybe<VerticalTabCollection>;
  verticalTabListCollection?: Maybe<VerticalTabListCollection>;
};


export type AssetLinkingCollectionsAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsBlogSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsHeroWithCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsImageAndTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsLogoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsSecurityTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsSeoFieldsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsVerticalTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsVerticalTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type Author = Entry & _Node & {
  __typename?: 'Author';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<AuthorLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type AuthorDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type AuthorImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type AuthorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type AuthorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/author) */
export type AuthorTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorCollection = {
  __typename?: 'AuthorCollection';
  items: Array<Maybe<Author>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AuthorFilter = {
  AND?: InputMaybe<Array<InputMaybe<AuthorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AuthorFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthorLinkingCollections = {
  __typename?: 'AuthorLinkingCollections';
  articleCollection?: Maybe<ArticleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AuthorLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorLinkingCollectionsArticleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AuthorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AuthorLinkingCollectionsArticleCollectionOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AuthorOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/banner) */
export type Banner = Entry & _Node & {
  __typename?: 'Banner';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Asset>;
  link?: Maybe<Link>;
  linkedFrom?: Maybe<BannerLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/banner) */
export type BannerIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/banner) */
export type BannerLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/banner) */
export type BannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/banner) */
export type BannerTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BannerCollection = {
  __typename?: 'BannerCollection';
  items: Array<Maybe<Banner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<CfLinkNestedFilter>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BannerLinkingCollections = {
  __typename?: 'BannerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum BannerOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSection = Entry & _Node & {
  __typename?: 'BlogSection';
  _id: Scalars['ID']['output'];
  backgroundImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  featuredBlog?: Maybe<Article>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlogSectionLinkingCollections>;
  seoFields?: Maybe<SeoFields>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionFeaturedBlogArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionSeoFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SeoFieldsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/blogSection) */
export type BlogSectionTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogSectionCollection = {
  __typename?: 'BlogSectionCollection';
  items: Array<Maybe<BlogSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogSectionFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredBlog?: InputMaybe<CfArticleNestedFilter>;
  featuredBlog_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoFields?: InputMaybe<CfSeoFieldsNestedFilter>;
  seoFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogSectionLinkingCollections = {
  __typename?: 'BlogSectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum BlogSectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type Button = Entry & _Node & {
  __typename?: 'Button';
  _id: Scalars['ID']['output'];
  buttonImage?: Maybe<Asset>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ButtonLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type ButtonButtonImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type ButtonButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type ButtonButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type ButtonButtonTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/button) */
export type ButtonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ButtonCollection = {
  __typename?: 'ButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ButtonFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  buttonImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ButtonLinkingCollections = {
  __typename?: 'ButtonLinkingCollections';
  adobeSummitCollection?: Maybe<AdobeSummitCollection>;
  articleListCollection?: Maybe<ArticleListCollection>;
  entryCollection?: Maybe<EntryCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroWithCardsCollection?: Maybe<HeroWithCardsCollection>;
  imageAndTextCollection?: Maybe<ImageAndTextCollection>;
  logoListCollection?: Maybe<LogoListCollection>;
};


export type ButtonLinkingCollectionsAdobeSummitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAdobeSummitCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsArticleListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsArticleListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsHeroWithCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeroWithCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsImageAndTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsImageAndTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsLogoListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsLogoListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ButtonLinkingCollectionsAdobeSummitCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ButtonLinkingCollectionsArticleListCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ButtonLinkingCollectionsHeaderCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ButtonLinkingCollectionsHeroCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ButtonLinkingCollectionsHeroWithCardsCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HeroTitleAsc = 'heroTitle_ASC',
  HeroTitleDesc = 'heroTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ButtonLinkingCollectionsImageAndTextCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ButtonLinkingCollectionsLogoListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ButtonOrder {
  ButtonLinkAsc = 'buttonLink_ASC',
  ButtonLinkDesc = 'buttonLink_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type Card = Entry & _Node & {
  __typename?: 'Card';
  _id: Scalars['ID']['output'];
  cardBackgroundImage?: Maybe<Asset>;
  cardDescription?: Maybe<CardCardDescription>;
  cardEyebrowText?: Maybe<Scalars['String']['output']>;
  cardIcon?: Maybe<Asset>;
  cardImage?: Maybe<Asset>;
  cardLink?: Maybe<Scalars['String']['output']>;
  cardLinkText?: Maybe<Scalars['String']['output']>;
  cardTitle?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<CardLinkingCollections>;
  subDescription?: Maybe<CardSubDescription>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/card) */
export type CardSubDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CardCardDescription = {
  __typename?: 'CardCardDescription';
  json: Scalars['JSON']['output'];
  links: CardCardDescriptionLinks;
};

export type CardCardDescriptionAssets = {
  __typename?: 'CardCardDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CardCardDescriptionEntries = {
  __typename?: 'CardCardDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CardCardDescriptionLinks = {
  __typename?: 'CardCardDescriptionLinks';
  assets: CardCardDescriptionAssets;
  entries: CardCardDescriptionEntries;
  resources: CardCardDescriptionResources;
};

export type CardCardDescriptionResources = {
  __typename?: 'CardCardDescriptionResources';
  block: Array<CardCardDescriptionResourcesBlock>;
  hyperlink: Array<CardCardDescriptionResourcesHyperlink>;
  inline: Array<CardCardDescriptionResourcesInline>;
};

export type CardCardDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'CardCardDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type CardCardDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'CardCardDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type CardCardDescriptionResourcesInline = ResourceLink & {
  __typename?: 'CardCardDescriptionResourcesInline';
  sys: ResourceSys;
};

export type CardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  cardBackgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  cardDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardEyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardEyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLink?: InputMaybe<Scalars['String']['input']>;
  cardLinkText?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLinkText_not?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLink_contains?: InputMaybe<Scalars['String']['input']>;
  cardLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLink_not?: InputMaybe<Scalars['String']['input']>;
  cardLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  cardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  cardTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTitle_not?: InputMaybe<Scalars['String']['input']>;
  cardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  subDescription_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  adobeSummitCollection?: Maybe<AdobeSummitCollection>;
  cardListCollection?: Maybe<CardListCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroWithCardsCollection?: Maybe<HeroWithCardsCollection>;
};


export type CardLinkingCollectionsAdobeSummitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsAdobeSummitCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CardLinkingCollectionsCardListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsCardListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CardLinkingCollectionsHeroWithCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsHeroWithCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CardLinkingCollectionsAdobeSummitCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CardLinkingCollectionsCardListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CardLinkingCollectionsHeroWithCardsCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HeroTitleAsc = 'heroTitle_ASC',
  HeroTitleDesc = 'heroTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardList = Entry & _Node & {
  __typename?: 'CardList';
  _id: Scalars['ID']['output'];
  cardsCollection?: Maybe<CardListCardsCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CardListLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardListCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/cardList) */
export type CardListVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CardListCardsCollection = {
  __typename?: 'CardListCardsCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CardListCardsCollectionOrder {
  CardEyebrowTextAsc = 'cardEyebrowText_ASC',
  CardEyebrowTextDesc = 'cardEyebrowText_DESC',
  CardLinkTextAsc = 'cardLinkText_ASC',
  CardLinkTextDesc = 'cardLinkText_DESC',
  CardLinkAsc = 'cardLink_ASC',
  CardLinkDesc = 'cardLink_DESC',
  CardTitleAsc = 'cardTitle_ASC',
  CardTitleDesc = 'cardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CardListCollection = {
  __typename?: 'CardListCollection';
  items: Array<Maybe<CardList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardListFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardListFilter>>>;
  cards?: InputMaybe<CfCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CardListLinkingCollections = {
  __typename?: 'CardListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CardListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CardListOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CardOrder {
  CardEyebrowTextAsc = 'cardEyebrowText_ASC',
  CardEyebrowTextDesc = 'cardEyebrowText_DESC',
  CardLinkTextAsc = 'cardLinkText_ASC',
  CardLinkTextDesc = 'cardLinkText_DESC',
  CardLinkAsc = 'cardLink_ASC',
  CardLinkDesc = 'cardLink_DESC',
  CardTitleAsc = 'cardTitle_ASC',
  CardTitleDesc = 'cardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CardSubDescription = {
  __typename?: 'CardSubDescription';
  json: Scalars['JSON']['output'];
  links: CardSubDescriptionLinks;
};

export type CardSubDescriptionAssets = {
  __typename?: 'CardSubDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CardSubDescriptionEntries = {
  __typename?: 'CardSubDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CardSubDescriptionLinks = {
  __typename?: 'CardSubDescriptionLinks';
  assets: CardSubDescriptionAssets;
  entries: CardSubDescriptionEntries;
  resources: CardSubDescriptionResources;
};

export type CardSubDescriptionResources = {
  __typename?: 'CardSubDescriptionResources';
  block: Array<CardSubDescriptionResourcesBlock>;
  hyperlink: Array<CardSubDescriptionResourcesHyperlink>;
  inline: Array<CardSubDescriptionResourcesInline>;
};

export type CardSubDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'CardSubDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type CardSubDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'CardSubDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type CardSubDescriptionResourcesInline = ResourceLink & {
  __typename?: 'CardSubDescriptionResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/contentTile) */
export type ContentTile = Entry & _Node & {
  __typename?: 'ContentTile';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<ContentTileLinkingCollections>;
  sys: Sys;
  text?: Maybe<ContentTileText>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/contentTile) */
export type ContentTileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/contentTile) */
export type ContentTileLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/contentTile) */
export type ContentTileTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/contentTile) */
export type ContentTileTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTileCollection = {
  __typename?: 'ContentTileCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTileFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTileLinkingCollections = {
  __typename?: 'ContentTileLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ContentTileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentTileOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentTileText = {
  __typename?: 'ContentTileText';
  json: Scalars['JSON']['output'];
  links: ContentTileTextLinks;
};

export type ContentTileTextAssets = {
  __typename?: 'ContentTileTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTileTextEntries = {
  __typename?: 'ContentTileTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTileTextLinks = {
  __typename?: 'ContentTileTextLinks';
  assets: ContentTileTextAssets;
  entries: ContentTileTextEntries;
  resources: ContentTileTextResources;
};

export type ContentTileTextResources = {
  __typename?: 'ContentTileTextResources';
  block: Array<ContentTileTextResourcesBlock>;
  hyperlink: Array<ContentTileTextResourcesHyperlink>;
  inline: Array<ContentTileTextResourcesInline>;
};

export type ContentTileTextResourcesBlock = ResourceLink & {
  __typename?: 'ContentTileTextResourcesBlock';
  sys: ResourceSys;
};

export type ContentTileTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTileTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTileTextResourcesInline = ResourceLink & {
  __typename?: 'ContentTileTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichText = Entry & _Node & {
  __typename?: 'ContentTypeRichText';
  _id: Scalars['ID']['output'];
  banner?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ContentTypeRichTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<ContentTypeRichTextText>;
  title?: Maybe<Scalars['String']['output']>;
  titleText?: Maybe<ContentTypeRichTextTitleText>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichTextBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichTextTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/richText) */
export type ContentTypeRichTextTitleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTypeRichTextCollection = {
  __typename?: 'ContentTypeRichTextCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTypeRichTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  banner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTypeRichTextLinkingCollections = {
  __typename?: 'ContentTypeRichTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ContentTypeRichTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentTypeRichTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentTypeRichTextText = {
  __typename?: 'ContentTypeRichTextText';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextTextLinks;
};

export type ContentTypeRichTextTextAssets = {
  __typename?: 'ContentTypeRichTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextTextEntries = {
  __typename?: 'ContentTypeRichTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextTextLinks = {
  __typename?: 'ContentTypeRichTextTextLinks';
  assets: ContentTypeRichTextTextAssets;
  entries: ContentTypeRichTextTextEntries;
  resources: ContentTypeRichTextTextResources;
};

export type ContentTypeRichTextTextResources = {
  __typename?: 'ContentTypeRichTextTextResources';
  block: Array<ContentTypeRichTextTextResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextTextResourcesHyperlink>;
  inline: Array<ContentTypeRichTextTextResourcesInline>;
};

export type ContentTypeRichTextTextResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextTextResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextTextResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextTextResourcesInline';
  sys: ResourceSys;
};

export type ContentTypeRichTextTitleText = {
  __typename?: 'ContentTypeRichTextTitleText';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextTitleTextLinks;
};

export type ContentTypeRichTextTitleTextAssets = {
  __typename?: 'ContentTypeRichTextTitleTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextTitleTextEntries = {
  __typename?: 'ContentTypeRichTextTitleTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextTitleTextLinks = {
  __typename?: 'ContentTypeRichTextTitleTextLinks';
  assets: ContentTypeRichTextTitleTextAssets;
  entries: ContentTypeRichTextTitleTextEntries;
  resources: ContentTypeRichTextTitleTextResources;
};

export type ContentTypeRichTextTitleTextResources = {
  __typename?: 'ContentTypeRichTextTitleTextResources';
  block: Array<ContentTypeRichTextTitleTextResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextTitleTextResourcesHyperlink>;
  inline: Array<ContentTypeRichTextTitleTextResourcesInline>;
};

export type ContentTypeRichTextTitleTextResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextTitleTextResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextTitleTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextTitleTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextTitleTextResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextTitleTextResourcesInline';
  sys: ResourceSys;
};

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type Footer = Entry & _Node & {
  __typename?: 'Footer';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copyrightText?: Maybe<Scalars['String']['output']>;
  footerLinksCollection?: Maybe<FooterFooterLinksCollection>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FooterLinkingCollections>;
  logo?: Maybe<Logo>;
  socialMediaLinksCollection?: Maybe<FooterSocialMediaLinksCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterCopyrightTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterFooterLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterFooterLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterSectionLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LogoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footer) */
export type FooterSocialMediaLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterSocialMediaLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};

export type FooterCollection = {
  __typename?: 'FooterCollection';
  items: Array<Maybe<Footer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyrightText?: InputMaybe<Scalars['String']['input']>;
  copyrightText_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyrightText_not?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerLinks?: InputMaybe<CfFooterSectionLinksNestedFilter>;
  footerLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<CfLogoNestedFilter>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaLinks?: InputMaybe<CfLinkNestedFilter>;
  socialMediaLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterFooterLinksCollection = {
  __typename?: 'FooterFooterLinksCollection';
  items: Array<Maybe<FooterSectionLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FooterFooterLinksCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterLinkingCollections = {
  __typename?: 'FooterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type FooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum FooterOrder {
  CopyrightTextAsc = 'copyrightText_ASC',
  CopyrightTextDesc = 'copyrightText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footerSectionLinks) */
export type FooterSectionLinks = Entry & _Node & {
  __typename?: 'FooterSectionLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FooterSectionLinksLinkingCollections>;
  linksCollection?: Maybe<FooterSectionLinksLinksCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footerSectionLinks) */
export type FooterSectionLinksHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footerSectionLinks) */
export type FooterSectionLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/footerSectionLinks) */
export type FooterSectionLinksLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterSectionLinksLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};

export type FooterSectionLinksCollection = {
  __typename?: 'FooterSectionLinksCollection';
  items: Array<Maybe<FooterSectionLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterSectionLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterSectionLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterSectionLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  links?: InputMaybe<CfLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterSectionLinksLinkingCollections = {
  __typename?: 'FooterSectionLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  footerCollection?: Maybe<FooterCollection>;
};


export type FooterSectionLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterSectionLinksLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterSectionLinksLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum FooterSectionLinksLinkingCollectionsFooterCollectionOrder {
  CopyrightTextAsc = 'copyrightText_ASC',
  CopyrightTextDesc = 'copyrightText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterSectionLinksLinksCollection = {
  __typename?: 'FooterSectionLinksLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FooterSectionLinksLinksCollectionOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FooterSectionLinksOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterSocialMediaLinksCollection = {
  __typename?: 'FooterSocialMediaLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FooterSocialMediaLinksCollectionOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type Header = Entry & _Node & {
  __typename?: 'Header';
  _id: Scalars['ID']['output'];
  callToActionCollection?: Maybe<HeaderCallToActionCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<HeaderLinkingCollections>;
  logoCollection?: Maybe<HeaderLogoCollection>;
  navigationLinksCollection?: Maybe<HeaderNavigationLinksCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type HeaderCallToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderCallToActionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type HeaderInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type HeaderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type HeaderLogoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderLogoCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LogoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/header) */
export type HeaderNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavigationLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};

export type HeaderCallToActionCollection = {
  __typename?: 'HeaderCallToActionCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HeaderCallToActionCollectionOrder {
  ButtonLinkAsc = 'buttonLink_ASC',
  ButtonLinkDesc = 'buttonLink_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HeaderCollection = {
  __typename?: 'HeaderCollection';
  items: Array<Maybe<Header>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  callToAction?: InputMaybe<CfButtonNestedFilter>;
  callToActionCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<CfLogoNestedFilter>;
  logoCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationLinks?: InputMaybe<CfLinkNestedFilter>;
  navigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderLinkingCollections = {
  __typename?: 'HeaderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type HeaderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderLogoCollection = {
  __typename?: 'HeaderLogoCollection';
  items: Array<Maybe<Logo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HeaderLogoCollectionOrder {
  LogoNameAsc = 'logoName_ASC',
  LogoNameDesc = 'logoName_DESC',
  OpenInNewWindowAsc = 'openInNewWindow_ASC',
  OpenInNewWindowDesc = 'openInNewWindow_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WebsiteUrlAltTextAsc = 'websiteUrlAltText_ASC',
  WebsiteUrlAltTextDesc = 'websiteUrlAltText_DESC',
  WebsiteUrlAsc = 'websiteUrl_ASC',
  WebsiteUrlDesc = 'websiteUrl_DESC'
}

export type HeaderNavigationLinksCollection = {
  __typename?: 'HeaderNavigationLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HeaderNavigationLinksCollectionOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HeaderOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type Hero = Entry & _Node & {
  __typename?: 'Hero';
  _id: Scalars['ID']['output'];
  backgroundImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<HeroDescription>;
  heroImage?: Maybe<Asset>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<HeroLinkingCollections>;
  primaryButton?: Maybe<Button>;
  secondaryButton?: Maybe<Button>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleRtf?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroPrimaryButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroSecondaryButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/hero) */
export type HeroTitleRtfArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HeroCollection = {
  __typename?: 'HeroCollection';
  items: Array<Maybe<Hero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroDescription = {
  __typename?: 'HeroDescription';
  json: Scalars['JSON']['output'];
  links: HeroDescriptionLinks;
};

export type HeroDescriptionAssets = {
  __typename?: 'HeroDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroDescriptionEntries = {
  __typename?: 'HeroDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroDescriptionLinks = {
  __typename?: 'HeroDescriptionLinks';
  assets: HeroDescriptionAssets;
  entries: HeroDescriptionEntries;
  resources: HeroDescriptionResources;
};

export type HeroDescriptionResources = {
  __typename?: 'HeroDescriptionResources';
  block: Array<HeroDescriptionResourcesBlock>;
  hyperlink: Array<HeroDescriptionResourcesHyperlink>;
  inline: Array<HeroDescriptionResourcesInline>;
};

export type HeroDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'HeroDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type HeroDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroDescriptionResourcesInline = ResourceLink & {
  __typename?: 'HeroDescriptionResourcesInline';
  sys: ResourceSys;
};

export type HeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryButton?: InputMaybe<CfButtonNestedFilter>;
  primaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryButton?: InputMaybe<CfButtonNestedFilter>;
  secondaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleRtf?: InputMaybe<Scalars['String']['input']>;
  titleRtf_contains?: InputMaybe<Scalars['String']['input']>;
  titleRtf_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleRtf_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleRtf_not?: InputMaybe<Scalars['String']['input']>;
  titleRtf_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleRtf_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HeroLinkingCollections = {
  __typename?: 'HeroLinkingCollections';
  adobeSummitCollection?: Maybe<AdobeSummitCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type HeroLinkingCollectionsAdobeSummitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsAdobeSummitCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum HeroLinkingCollectionsAdobeSummitCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCards = Entry & _Node & {
  __typename?: 'HeroWithCards';
  _id: Scalars['ID']['output'];
  backgroundImage?: Maybe<Asset>;
  buttonLink?: Maybe<Button>;
  cardsCollection?: Maybe<HeroWithCardsCardsCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<HeroWithCardsDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  foregroundImage?: Maybe<Asset>;
  heroTitle?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<HeroWithCardsLinkingCollections>;
  sys: Sys;
  titleIcon?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroWithCardsCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsForegroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsHeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/heroWithCards) */
export type HeroWithCardsTitleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroWithCardsCardsCollection = {
  __typename?: 'HeroWithCardsCardsCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HeroWithCardsCardsCollectionOrder {
  CardEyebrowTextAsc = 'cardEyebrowText_ASC',
  CardEyebrowTextDesc = 'cardEyebrowText_DESC',
  CardLinkTextAsc = 'cardLinkText_ASC',
  CardLinkTextDesc = 'cardLinkText_DESC',
  CardLinkAsc = 'cardLink_ASC',
  CardLinkDesc = 'cardLink_DESC',
  CardTitleAsc = 'cardTitle_ASC',
  CardTitleDesc = 'cardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HeroWithCardsCollection = {
  __typename?: 'HeroWithCardsCollection';
  items: Array<Maybe<HeroWithCards>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroWithCardsDescription = {
  __typename?: 'HeroWithCardsDescription';
  json: Scalars['JSON']['output'];
  links: HeroWithCardsDescriptionLinks;
};

export type HeroWithCardsDescriptionAssets = {
  __typename?: 'HeroWithCardsDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroWithCardsDescriptionEntries = {
  __typename?: 'HeroWithCardsDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroWithCardsDescriptionLinks = {
  __typename?: 'HeroWithCardsDescriptionLinks';
  assets: HeroWithCardsDescriptionAssets;
  entries: HeroWithCardsDescriptionEntries;
  resources: HeroWithCardsDescriptionResources;
};

export type HeroWithCardsDescriptionResources = {
  __typename?: 'HeroWithCardsDescriptionResources';
  block: Array<HeroWithCardsDescriptionResourcesBlock>;
  hyperlink: Array<HeroWithCardsDescriptionResourcesHyperlink>;
  inline: Array<HeroWithCardsDescriptionResourcesInline>;
};

export type HeroWithCardsDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'HeroWithCardsDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type HeroWithCardsDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroWithCardsDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroWithCardsDescriptionResourcesInline = ResourceLink & {
  __typename?: 'HeroWithCardsDescriptionResourcesInline';
  sys: ResourceSys;
};

export type HeroWithCardsFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroWithCardsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroWithCardsFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<CfButtonNestedFilter>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CfCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  foregroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  heroTitle_contains?: InputMaybe<Scalars['String']['input']>;
  heroTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroTitle_not?: InputMaybe<Scalars['String']['input']>;
  heroTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroWithCardsLinkingCollections = {
  __typename?: 'HeroWithCardsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type HeroWithCardsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum HeroWithCardsOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HeroTitleAsc = 'heroTitle_ASC',
  HeroTitleDesc = 'heroTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndText = Entry & _Node & {
  __typename?: 'ImageAndText';
  _id: Scalars['ID']['output'];
  additionalText?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Asset>;
  buttonLink?: Maybe<Button>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ImageAndTextDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ImageAndTextLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  videofile?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextAdditionalTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndText) */
export type ImageAndTextVideofileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAndTextCollection = {
  __typename?: 'ImageAndTextCollection';
  items: Array<Maybe<ImageAndText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ImageAndTextDescription = {
  __typename?: 'ImageAndTextDescription';
  json: Scalars['JSON']['output'];
  links: ImageAndTextDescriptionLinks;
};

export type ImageAndTextDescriptionAssets = {
  __typename?: 'ImageAndTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ImageAndTextDescriptionEntries = {
  __typename?: 'ImageAndTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ImageAndTextDescriptionLinks = {
  __typename?: 'ImageAndTextDescriptionLinks';
  assets: ImageAndTextDescriptionAssets;
  entries: ImageAndTextDescriptionEntries;
  resources: ImageAndTextDescriptionResources;
};

export type ImageAndTextDescriptionResources = {
  __typename?: 'ImageAndTextDescriptionResources';
  block: Array<ImageAndTextDescriptionResourcesBlock>;
  hyperlink: Array<ImageAndTextDescriptionResourcesHyperlink>;
  inline: Array<ImageAndTextDescriptionResourcesInline>;
};

export type ImageAndTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ImageAndTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ImageAndTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ImageAndTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ImageAndTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ImageAndTextDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ImageAndTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageAndTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageAndTextFilter>>>;
  additionalText?: InputMaybe<Scalars['String']['input']>;
  additionalText_contains?: InputMaybe<Scalars['String']['input']>;
  additionalText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  additionalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalText_not?: InputMaybe<Scalars['String']['input']>;
  additionalText_not_contains?: InputMaybe<Scalars['String']['input']>;
  additionalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<CfButtonNestedFilter>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videofile_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAndTextLinkingCollections = {
  __typename?: 'ImageAndTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  imageAndTextListCollection?: Maybe<ImageAndTextListCollection>;
};


export type ImageAndTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextLinkingCollectionsImageAndTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAndTextLinkingCollectionsImageAndTextListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ImageAndTextLinkingCollectionsImageAndTextListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextList = Entry & _Node & {
  __typename?: 'ImageAndTextList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  imageAndTextListCollection?: Maybe<ImageAndTextListImageAndTextListCollection>;
  linkedFrom?: Maybe<ImageAndTextListLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextListEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextListImageAndTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAndTextListImageAndTextListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/imageAndTextList) */
export type ImageAndTextListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextListCollection = {
  __typename?: 'ImageAndTextListCollection';
  items: Array<Maybe<ImageAndTextList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ImageAndTextListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageAndTextListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageAndTextListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAndTextList?: InputMaybe<CfImageAndTextNestedFilter>;
  imageAndTextListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ImageAndTextListImageAndTextListCollection = {
  __typename?: 'ImageAndTextListImageAndTextListCollection';
  items: Array<Maybe<ImageAndText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ImageAndTextListImageAndTextListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type ImageAndTextListLinkingCollections = {
  __typename?: 'ImageAndTextListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ImageAndTextListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ImageAndTextListOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageAndTextOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/layoutComponents) */
export type LayoutComponents = Entry & _Node & {
  __typename?: 'LayoutComponents';
  _id: Scalars['ID']['output'];
  componentsCollection?: Maybe<LayoutComponentsComponentsCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LayoutComponentsLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/layoutComponents) */
export type LayoutComponentsComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/layoutComponents) */
export type LayoutComponentsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/layoutComponents) */
export type LayoutComponentsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LayoutComponentsCollection = {
  __typename?: 'LayoutComponentsCollection';
  items: Array<Maybe<LayoutComponents>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LayoutComponentsComponentsCollection = {
  __typename?: 'LayoutComponentsComponentsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LayoutComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<LayoutComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LayoutComponentsFilter>>>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type LayoutComponentsLinkingCollections = {
  __typename?: 'LayoutComponentsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LayoutComponentsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LayoutComponentsOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type Link = Entry & _Node & {
  __typename?: 'Link';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkAltText?: Maybe<Scalars['String']['output']>;
  linkIcon?: Maybe<Asset>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LinkLinkingCollections>;
  openInNewWindow?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkLinkAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkLinkIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/link) */
export type LinkOpenInNewWindowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LinkCollection = {
  __typename?: 'LinkCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  linkAltText?: InputMaybe<Scalars['String']['input']>;
  linkAltText_contains?: InputMaybe<Scalars['String']['input']>;
  linkAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkAltText_not?: InputMaybe<Scalars['String']['input']>;
  linkAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type LinkLinkingCollections = {
  __typename?: 'LinkLinkingCollections';
  articleCollection?: Maybe<ArticleCollection>;
  bannerCollection?: Maybe<BannerCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footerCollection?: Maybe<FooterCollection>;
  footerSectionLinksCollection?: Maybe<FooterSectionLinksCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  listOfLinksCollection?: Maybe<ListOfLinksCollection>;
  locationCardCollection?: Maybe<LocationCardCollection>;
  locationListCollection?: Maybe<LocationListCollection>;
  menuItemCollection?: Maybe<MenuItemCollection>;
};


export type LinkLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsArticleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsFooterSectionLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsFooterSectionLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsListOfLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsListOfLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsLocationCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsLocationCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsLocationListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsLocationListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkLinkingCollectionsMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsMenuItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LinkLinkingCollectionsArticleCollectionOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LinkLinkingCollectionsBannerCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LinkLinkingCollectionsFooterCollectionOrder {
  CopyrightTextAsc = 'copyrightText_ASC',
  CopyrightTextDesc = 'copyrightText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsFooterSectionLinksCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsHeaderCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsListOfLinksCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsLocationCardCollectionOrder {
  InformationAsc = 'information_ASC',
  InformationDesc = 'information_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LinkLinkingCollectionsLocationListCollectionOrder {
  InformationAsc = 'information_ASC',
  InformationDesc = 'information_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LinkLinkingCollectionsMenuItemCollectionOrder {
  OpenInNewTabAsc = 'openInNewTab_ASC',
  OpenInNewTabDesc = 'openInNewTab_DESC',
  OrderpositionAsc = 'orderposition_ASC',
  OrderpositionDesc = 'orderposition_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/linkList) */
export type LinkList = Entry & _Node & {
  __typename?: 'LinkList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LinkListLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/linkList) */
export type LinkListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LinkListCollection = {
  __typename?: 'LinkListCollection';
  items: Array<Maybe<LinkList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LinkListFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type LinkListLinkingCollections = {
  __typename?: 'LinkListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LinkListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LinkListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLinks) */
export type ListOfLinks = Entry & _Node & {
  __typename?: 'ListOfLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkListCollection?: Maybe<ListOfLinksLinkListCollection>;
  linkedFrom?: Maybe<ListOfLinksLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLinks) */
export type ListOfLinksInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLinks) */
export type ListOfLinksLinkListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOfLinksLinkListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLinks) */
export type ListOfLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ListOfLinksCollection = {
  __typename?: 'ListOfLinksCollection';
  items: Array<Maybe<ListOfLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListOfLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListOfLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListOfLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkList?: InputMaybe<CfLinkNestedFilter>;
  linkListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ListOfLinksLinkListCollection = {
  __typename?: 'ListOfLinksLinkListCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ListOfLinksLinkListCollectionOrder {
  LinkAltTextAsc = 'linkAltText_ASC',
  LinkAltTextDesc = 'linkAltText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ListOfLinksLinkingCollections = {
  __typename?: 'ListOfLinksLinkingCollections';
  articleCollection?: Maybe<ArticleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type ListOfLinksLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOfLinksLinkingCollectionsArticleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ListOfLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ListOfLinksLinkingCollectionsArticleCollectionOrder {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubDescriptionAsc = 'subDescription_ASC',
  SubDescriptionDesc = 'subDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ListOfLinksOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLocation) */
export type ListOfLocation = Entry & _Node & {
  __typename?: 'ListOfLocation';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ListOfLocationLinkingCollections>;
  listOfLocationCollection?: Maybe<ListOfLocationListOfLocationCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLocation) */
export type ListOfLocationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/listOfLocation) */
export type ListOfLocationListOfLocationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOfLocationListOfLocationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationCardFilter>;
};

export type ListOfLocationCollection = {
  __typename?: 'ListOfLocationCollection';
  items: Array<Maybe<ListOfLocation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListOfLocationFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListOfLocationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListOfLocationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  listOfLocation?: InputMaybe<CfLocationCardNestedFilter>;
  listOfLocationCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ListOfLocationLinkingCollections = {
  __typename?: 'ListOfLocationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ListOfLocationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ListOfLocationListOfLocationCollection = {
  __typename?: 'ListOfLocationListOfLocationCollection';
  items: Array<Maybe<LocationCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ListOfLocationListOfLocationCollectionOrder {
  InformationAsc = 'information_ASC',
  InformationDesc = 'information_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ListOfLocationOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationCard) */
export type LocationCard = Entry & _Node & {
  __typename?: 'LocationCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Link>;
  information?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LocationCardLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationCard) */
export type LocationCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationCard) */
export type LocationCardInformationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationCard) */
export type LocationCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationCard) */
export type LocationCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LocationCardCollection = {
  __typename?: 'LocationCardCollection';
  items: Array<Maybe<LocationCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LocationCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<LocationCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfLinkNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  information_contains?: InputMaybe<Scalars['String']['input']>;
  information_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  information_not?: InputMaybe<Scalars['String']['input']>;
  information_not_contains?: InputMaybe<Scalars['String']['input']>;
  information_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationCardLinkingCollections = {
  __typename?: 'LocationCardLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  listOfLocationCollection?: Maybe<ListOfLocationCollection>;
};


export type LocationCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationCardLinkingCollectionsListOfLocationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocationCardLinkingCollectionsListOfLocationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LocationCardLinkingCollectionsListOfLocationCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LocationCardOrder {
  InformationAsc = 'information_ASC',
  InformationDesc = 'information_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationList) */
export type LocationList = Entry & _Node & {
  __typename?: 'LocationList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Link>;
  information?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LocationListLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationList) */
export type LocationListIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationList) */
export type LocationListInformationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationList) */
export type LocationListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/locationList) */
export type LocationListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LocationListCollection = {
  __typename?: 'LocationListCollection';
  items: Array<Maybe<LocationList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LocationListFilter = {
  AND?: InputMaybe<Array<InputMaybe<LocationListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfLinkNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  information_contains?: InputMaybe<Scalars['String']['input']>;
  information_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  information_not?: InputMaybe<Scalars['String']['input']>;
  information_not_contains?: InputMaybe<Scalars['String']['input']>;
  information_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationListLinkingCollections = {
  __typename?: 'LocationListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LocationListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LocationListOrder {
  InformationAsc = 'information_ASC',
  InformationDesc = 'information_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type Logo = Entry & _Node & {
  __typename?: 'Logo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LogoLinkingCollections>;
  logoImage?: Maybe<Asset>;
  logoName?: Maybe<Scalars['String']['output']>;
  openInNewWindow?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  websiteUrlAltText?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoLogoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoLogoNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoOpenInNewWindowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoWebsiteUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logo) */
export type LogoWebsiteUrlAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LogoCollection = {
  __typename?: 'LogoCollection';
  items: Array<Maybe<Logo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LogoFilter = {
  AND?: InputMaybe<Array<InputMaybe<LogoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LogoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  logoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  logoName_contains?: InputMaybe<Scalars['String']['input']>;
  logoName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoName_not?: InputMaybe<Scalars['String']['input']>;
  logoName_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_contains?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_not?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_not_contains?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrlAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrlAltText_not?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrl_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrl_not?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LogoLinkingCollections = {
  __typename?: 'LogoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  footerCollection?: Maybe<FooterCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  logoListCollection?: Maybe<LogoListCollection>;
};


export type LogoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LogoLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LogoLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LogoLinkingCollectionsLogoListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoLinkingCollectionsLogoListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LogoLinkingCollectionsFooterCollectionOrder {
  CopyrightTextAsc = 'copyrightText_ASC',
  CopyrightTextDesc = 'copyrightText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LogoLinkingCollectionsHeaderCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LogoLinkingCollectionsLogoListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoList = Entry & _Node & {
  __typename?: 'LogoList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<LogoListDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LogoListLinkingCollections>;
  logoListButton?: Maybe<Button>;
  logosCollection?: Maybe<LogoListLogosCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListLogoListButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListLogosCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoListLogosCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LogoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/logoList) */
export type LogoListVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LogoListCollection = {
  __typename?: 'LogoListCollection';
  items: Array<Maybe<LogoList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LogoListDescription = {
  __typename?: 'LogoListDescription';
  json: Scalars['JSON']['output'];
  links: LogoListDescriptionLinks;
};

export type LogoListDescriptionAssets = {
  __typename?: 'LogoListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type LogoListDescriptionEntries = {
  __typename?: 'LogoListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type LogoListDescriptionLinks = {
  __typename?: 'LogoListDescriptionLinks';
  assets: LogoListDescriptionAssets;
  entries: LogoListDescriptionEntries;
  resources: LogoListDescriptionResources;
};

export type LogoListDescriptionResources = {
  __typename?: 'LogoListDescriptionResources';
  block: Array<LogoListDescriptionResourcesBlock>;
  hyperlink: Array<LogoListDescriptionResourcesHyperlink>;
  inline: Array<LogoListDescriptionResourcesInline>;
};

export type LogoListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'LogoListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type LogoListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'LogoListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type LogoListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'LogoListDescriptionResourcesInline';
  sys: ResourceSys;
};

export type LogoListFilter = {
  AND?: InputMaybe<Array<InputMaybe<LogoListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LogoListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoListButton?: InputMaybe<CfButtonNestedFilter>;
  logoListButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logos?: InputMaybe<CfLogoNestedFilter>;
  logosCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LogoListLinkingCollections = {
  __typename?: 'LogoListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LogoListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoListLogosCollection = {
  __typename?: 'LogoListLogosCollection';
  items: Array<Maybe<Logo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LogoListLogosCollectionOrder {
  LogoNameAsc = 'logoName_ASC',
  LogoNameDesc = 'logoName_DESC',
  OpenInNewWindowAsc = 'openInNewWindow_ASC',
  OpenInNewWindowDesc = 'openInNewWindow_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WebsiteUrlAltTextAsc = 'websiteUrlAltText_ASC',
  WebsiteUrlAltTextDesc = 'websiteUrlAltText_DESC',
  WebsiteUrlAsc = 'websiteUrl_ASC',
  WebsiteUrlDesc = 'websiteUrl_DESC'
}

export enum LogoListOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum LogoOrder {
  LogoNameAsc = 'logoName_ASC',
  LogoNameDesc = 'logoName_DESC',
  OpenInNewWindowAsc = 'openInNewWindow_ASC',
  OpenInNewWindowDesc = 'openInNewWindow_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WebsiteUrlAltTextAsc = 'websiteUrlAltText_ASC',
  WebsiteUrlAltTextDesc = 'websiteUrlAltText_DESC',
  WebsiteUrlAsc = 'websiteUrl_ASC',
  WebsiteUrlDesc = 'websiteUrl_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/lottieAnimation) */
export type LottieAnimation = Entry & _Node & {
  __typename?: 'LottieAnimation';
  _id: Scalars['ID']['output'];
  ariaLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LottieAnimationLinkingCollections>;
  lottieJson?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/lottieAnimation) */
export type LottieAnimationAriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/lottieAnimation) */
export type LottieAnimationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/lottieAnimation) */
export type LottieAnimationLottieJsonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LottieAnimationCollection = {
  __typename?: 'LottieAnimationCollection';
  items: Array<Maybe<LottieAnimation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LottieAnimationFilter = {
  AND?: InputMaybe<Array<InputMaybe<LottieAnimationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LottieAnimationFilter>>>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  ariaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  lottieJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type LottieAnimationLinkingCollections = {
  __typename?: 'LottieAnimationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LottieAnimationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum LottieAnimationOrder {
  AriaLabelAsc = 'ariaLabel_ASC',
  AriaLabelDesc = 'ariaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menu) */
export type Menu = Entry & _Node & {
  __typename?: 'Menu';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<MenuLinkingCollections>;
  menuItemsCollection?: Maybe<MenuMenuItemsCollection>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menu) */
export type MenuLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menu) */
export type MenuMenuItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MenuMenuItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menu) */
export type MenuNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MenuCollection = {
  __typename?: 'MenuCollection';
  items: Array<Maybe<Menu>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MenuFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  menuItems?: InputMaybe<CfMenuItemNestedFilter>;
  menuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItem = Entry & _Node & {
  __typename?: 'MenuItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Asset>;
  linkText?: Maybe<Link>;
  linkedFrom?: Maybe<MenuItemLinkingCollections>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  orderposition?: Maybe<Scalars['Int']['output']>;
  parentItem?: Maybe<Entry>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemOpenInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemOrderpositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemParentItemArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/menuItem) */
export type MenuItemTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemCollection = {
  __typename?: 'MenuItemCollection';
  items: Array<Maybe<MenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MenuItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<CfLinkNestedFilter>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  orderposition?: InputMaybe<Scalars['Int']['input']>;
  orderposition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  orderposition_gt?: InputMaybe<Scalars['Int']['input']>;
  orderposition_gte?: InputMaybe<Scalars['Int']['input']>;
  orderposition_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  orderposition_lt?: InputMaybe<Scalars['Int']['input']>;
  orderposition_lte?: InputMaybe<Scalars['Int']['input']>;
  orderposition_not?: InputMaybe<Scalars['Int']['input']>;
  orderposition_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parentItem_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MenuItemLinkingCollections = {
  __typename?: 'MenuItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  menuCollection?: Maybe<MenuCollection>;
};


export type MenuItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemLinkingCollectionsMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MenuItemLinkingCollectionsMenuCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum MenuItemLinkingCollectionsMenuCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MenuItemOrder {
  OpenInNewTabAsc = 'openInNewTab_ASC',
  OpenInNewTabDesc = 'openInNewTab_DESC',
  OrderpositionAsc = 'orderposition_ASC',
  OrderpositionDesc = 'orderposition_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MenuLinkingCollections = {
  __typename?: 'MenuLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type MenuLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuMenuItemsCollection = {
  __typename?: 'MenuMenuItemsCollection';
  items: Array<Maybe<MenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MenuMenuItemsCollectionOrder {
  OpenInNewTabAsc = 'openInNewTab_ASC',
  OpenInNewTabDesc = 'openInNewTab_DESC',
  OrderpositionAsc = 'orderposition_ASC',
  OrderpositionDesc = 'orderposition_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MenuOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPage = Entry & _Node & {
  __typename?: 'PageBlogDetailPage';
  _id: Scalars['ID']['output'];
  blog?: Maybe<Article>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PageBlogDetailPageLinkingCollections>;
  seoFields?: Maybe<Entry>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageBlogArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageSeoFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageBlogDetailPage) */
export type PageBlogDetailPageTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogDetailPageCollection = {
  __typename?: 'PageBlogDetailPageCollection';
  items: Array<Maybe<PageBlogDetailPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageBlogDetailPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageBlogDetailPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageBlogDetailPageFilter>>>;
  blog?: InputMaybe<CfArticleNestedFilter>;
  blog_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageBlogDetailPageLinkingCollections = {
  __typename?: 'PageBlogDetailPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type PageBlogDetailPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum PageBlogDetailPageOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageGeneric) */
export type PageGeneric = Entry & _Node & {
  __typename?: 'PageGeneric';
  _id: Scalars['ID']['output'];
  componentsCollection?: Maybe<PageGenericComponentsCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PageGenericLinkingCollections>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageGeneric) */
export type PageGenericComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageGeneric) */
export type PageGenericInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageGeneric) */
export type PageGenericLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/pageGeneric) */
export type PageGenericSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericCollection = {
  __typename?: 'PageGenericCollection';
  items: Array<Maybe<PageGeneric>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageGenericComponentsCollection = {
  __typename?: 'PageGenericComponentsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageGenericFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageGenericFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageGenericFilter>>>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageGenericLinkingCollections = {
  __typename?: 'PageGenericLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type PageGenericLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum PageGenericOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type Profile = Entry & _Node & {
  __typename?: 'Profile';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<ProfileLinkingCollections>;
  logo?: Maybe<Asset>;
  position?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tagsCollection?: Maybe<ProfileTagsCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfileLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfileLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfilePositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfileTagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProfileTagsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profile) */
export type ProfileTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileCollection = {
  __typename?: 'ProfileCollection';
  items: Array<Maybe<Profile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProfileFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProfileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfileFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_contains?: InputMaybe<Scalars['String']['input']>;
  position_exists?: InputMaybe<Scalars['Boolean']['input']>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position_not?: InputMaybe<Scalars['String']['input']>;
  position_not_contains?: InputMaybe<Scalars['String']['input']>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags?: InputMaybe<CfTagsNestedFilter>;
  tagsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProfileLinkingCollections = {
  __typename?: 'ProfileLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  profilleDataCollection?: Maybe<ProfilleDataCollection>;
};


export type ProfileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileLinkingCollectionsProfilleDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProfileLinkingCollectionsProfilleDataCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProfileLinkingCollectionsProfilleDataCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProfileOrder {
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ProfileTagsCollection = {
  __typename?: 'ProfileTagsCollection';
  items: Array<Maybe<Tags>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ProfileTagsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profilleData) */
export type ProfilleData = Entry & _Node & {
  __typename?: 'ProfilleData';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProfilleDataLinkingCollections>;
  profileCollection?: Maybe<ProfilleDataProfileCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profilleData) */
export type ProfilleDataDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profilleData) */
export type ProfilleDataLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profilleData) */
export type ProfilleDataProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProfilleDataProfileCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/profilleData) */
export type ProfilleDataTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilleDataCollection = {
  __typename?: 'ProfilleDataCollection';
  items: Array<Maybe<ProfilleData>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProfilleDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProfilleDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfilleDataFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profile?: InputMaybe<CfProfileNestedFilter>;
  profileCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProfilleDataLinkingCollections = {
  __typename?: 'ProfilleDataLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProfilleDataLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProfilleDataOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ProfilleDataProfileCollection = {
  __typename?: 'ProfilleDataProfileCollection';
  items: Array<Maybe<Profile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ProfilleDataProfileCollectionOrder {
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  accordion?: Maybe<Accordion>;
  accordionCollection?: Maybe<AccordionCollection>;
  accordionItem?: Maybe<AccordionItem>;
  accordionItemCollection?: Maybe<AccordionItemCollection>;
  adobeSummit?: Maybe<AdobeSummit>;
  adobeSummitCollection?: Maybe<AdobeSummitCollection>;
  aiContent?: Maybe<AiContent>;
  aiContentCollection?: Maybe<AiContentCollection>;
  article?: Maybe<Article>;
  articleCollection?: Maybe<ArticleCollection>;
  articleList?: Maybe<ArticleList>;
  articleListCollection?: Maybe<ArticleListCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  author?: Maybe<Author>;
  authorCollection?: Maybe<AuthorCollection>;
  banner?: Maybe<Banner>;
  bannerCollection?: Maybe<BannerCollection>;
  blogSection?: Maybe<BlogSection>;
  blogSectionCollection?: Maybe<BlogSectionCollection>;
  button?: Maybe<Button>;
  buttonCollection?: Maybe<ButtonCollection>;
  card?: Maybe<Card>;
  cardCollection?: Maybe<CardCollection>;
  cardList?: Maybe<CardList>;
  cardListCollection?: Maybe<CardListCollection>;
  contentTile?: Maybe<ContentTile>;
  contentTileCollection?: Maybe<ContentTileCollection>;
  contentTypeRichText?: Maybe<ContentTypeRichText>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footer?: Maybe<Footer>;
  footerCollection?: Maybe<FooterCollection>;
  footerSectionLinks?: Maybe<FooterSectionLinks>;
  footerSectionLinksCollection?: Maybe<FooterSectionLinksCollection>;
  header?: Maybe<Header>;
  headerCollection?: Maybe<HeaderCollection>;
  hero?: Maybe<Hero>;
  heroCollection?: Maybe<HeroCollection>;
  heroWithCards?: Maybe<HeroWithCards>;
  heroWithCardsCollection?: Maybe<HeroWithCardsCollection>;
  imageAndText?: Maybe<ImageAndText>;
  imageAndTextCollection?: Maybe<ImageAndTextCollection>;
  imageAndTextList?: Maybe<ImageAndTextList>;
  imageAndTextListCollection?: Maybe<ImageAndTextListCollection>;
  layoutComponents?: Maybe<LayoutComponents>;
  layoutComponentsCollection?: Maybe<LayoutComponentsCollection>;
  link?: Maybe<Link>;
  linkCollection?: Maybe<LinkCollection>;
  linkList?: Maybe<LinkList>;
  linkListCollection?: Maybe<LinkListCollection>;
  listOfLinks?: Maybe<ListOfLinks>;
  listOfLinksCollection?: Maybe<ListOfLinksCollection>;
  listOfLocation?: Maybe<ListOfLocation>;
  listOfLocationCollection?: Maybe<ListOfLocationCollection>;
  locationCard?: Maybe<LocationCard>;
  locationCardCollection?: Maybe<LocationCardCollection>;
  locationList?: Maybe<LocationList>;
  locationListCollection?: Maybe<LocationListCollection>;
  logo?: Maybe<Logo>;
  logoCollection?: Maybe<LogoCollection>;
  logoList?: Maybe<LogoList>;
  logoListCollection?: Maybe<LogoListCollection>;
  lottieAnimation?: Maybe<LottieAnimation>;
  lottieAnimationCollection?: Maybe<LottieAnimationCollection>;
  menu?: Maybe<Menu>;
  menuCollection?: Maybe<MenuCollection>;
  menuItem?: Maybe<MenuItem>;
  menuItemCollection?: Maybe<MenuItemCollection>;
  pageBlogDetailPage?: Maybe<PageBlogDetailPage>;
  pageBlogDetailPageCollection?: Maybe<PageBlogDetailPageCollection>;
  pageGeneric?: Maybe<PageGeneric>;
  pageGenericCollection?: Maybe<PageGenericCollection>;
  profile?: Maybe<Profile>;
  profileCollection?: Maybe<ProfileCollection>;
  profilleData?: Maybe<ProfilleData>;
  profilleDataCollection?: Maybe<ProfilleDataCollection>;
  securityText?: Maybe<SecurityText>;
  securityTextCollection?: Maybe<SecurityTextCollection>;
  seoFields?: Maybe<SeoFields>;
  seoFieldsCollection?: Maybe<SeoFieldsCollection>;
  tab?: Maybe<Tab>;
  tabCollection?: Maybe<TabCollection>;
  tabList?: Maybe<TabList>;
  tabListCollection?: Maybe<TabListCollection>;
  tags?: Maybe<Tags>;
  tagsCollection?: Maybe<TagsCollection>;
  verticalTab?: Maybe<VerticalTab>;
  verticalTabCollection?: Maybe<VerticalTabCollection>;
  verticalTabList?: Maybe<VerticalTabList>;
  verticalTabListCollection?: Maybe<VerticalTabListCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccordionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionFilter>;
};


export type QueryAccordionItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemFilter>;
};


export type QueryAdobeSummitArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdobeSummitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdobeSummitOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AdobeSummitFilter>;
};


export type QueryAiContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAiContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AiContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AiContentFilter>;
};


export type QueryArticleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleFilter>;
};


export type QueryArticleListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticleListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ArticleListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleListFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAuthorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorFilter>;
};


export type QueryBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BannerFilter>;
};


export type QueryBlogSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogSectionFilter>;
};


export type QueryButtonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


export type QueryCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


export type QueryCardListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCardListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardListFilter>;
};


export type QueryContentTileArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


export type QueryContentTypeRichTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterFilter>;
};


export type QueryFooterSectionLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFooterSectionLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterSectionLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterSectionLinksFilter>;
};


export type QueryHeaderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


export type QueryHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroFilter>;
};


export type QueryHeroWithCardsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeroWithCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroWithCardsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroWithCardsFilter>;
};


export type QueryImageAndTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryImageAndTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAndTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextFilter>;
};


export type QueryImageAndTextListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryImageAndTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAndTextListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextListFilter>;
};


export type QueryLayoutComponentsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLayoutComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutComponentsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LayoutComponentsFilter>;
};


export type QueryLinkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkFilter>;
};


export type QueryLinkListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkListFilter>;
};


export type QueryListOfLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListOfLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOfLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ListOfLinksFilter>;
};


export type QueryListOfLocationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListOfLocationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOfLocationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ListOfLocationFilter>;
};


export type QueryLocationCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocationCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationCardFilter>;
};


export type QueryLocationListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocationListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationListFilter>;
};


export type QueryLogoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLogoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LogoFilter>;
};


export type QueryLogoListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLogoListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LogoListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LogoListFilter>;
};


export type QueryLottieAnimationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLottieAnimationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LottieAnimationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LottieAnimationFilter>;
};


export type QueryMenuArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MenuOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuFilter>;
};


export type QueryMenuItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MenuItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemFilter>;
};


export type QueryPageBlogDetailPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageBlogDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageBlogDetailPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageBlogDetailPageFilter>;
};


export type QueryPageGenericArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageGenericCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageGenericOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageGenericFilter>;
};


export type QueryProfileArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProfileOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileFilter>;
};


export type QueryProfilleDataArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProfilleDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProfilleDataOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfilleDataFilter>;
};


export type QuerySecurityTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySecurityTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SecurityTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SecurityTextFilter>;
};


export type QuerySeoFieldsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySeoFieldsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeoFieldsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SeoFieldsFilter>;
};


export type QueryTabArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabFilter>;
};


export type QueryTabListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabListFilter>;
};


export type QueryTagsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TagsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagsFilter>;
};


export type QueryVerticalTabArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVerticalTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VerticalTabOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalTabFilter>;
};


export type QueryVerticalTabListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVerticalTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VerticalTabListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalTabListFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityText = Entry & _Node & {
  __typename?: 'SecurityText';
  _id: Scalars['ID']['output'];
  banner?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SecurityTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<SecurityTextText>;
  title?: Maybe<Scalars['String']['output']>;
  titleText?: Maybe<SecurityTextTitleText>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityTextBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityTextTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/securityText) */
export type SecurityTextTitleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SecurityTextCollection = {
  __typename?: 'SecurityTextCollection';
  items: Array<Maybe<SecurityText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SecurityTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<SecurityTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SecurityTextFilter>>>;
  banner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SecurityTextLinkingCollections = {
  __typename?: 'SecurityTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type SecurityTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum SecurityTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SecurityTextText = {
  __typename?: 'SecurityTextText';
  json: Scalars['JSON']['output'];
  links: SecurityTextTextLinks;
};

export type SecurityTextTextAssets = {
  __typename?: 'SecurityTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SecurityTextTextEntries = {
  __typename?: 'SecurityTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SecurityTextTextLinks = {
  __typename?: 'SecurityTextTextLinks';
  assets: SecurityTextTextAssets;
  entries: SecurityTextTextEntries;
  resources: SecurityTextTextResources;
};

export type SecurityTextTextResources = {
  __typename?: 'SecurityTextTextResources';
  block: Array<SecurityTextTextResourcesBlock>;
  hyperlink: Array<SecurityTextTextResourcesHyperlink>;
  inline: Array<SecurityTextTextResourcesInline>;
};

export type SecurityTextTextResourcesBlock = ResourceLink & {
  __typename?: 'SecurityTextTextResourcesBlock';
  sys: ResourceSys;
};

export type SecurityTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'SecurityTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type SecurityTextTextResourcesInline = ResourceLink & {
  __typename?: 'SecurityTextTextResourcesInline';
  sys: ResourceSys;
};

export type SecurityTextTitleText = {
  __typename?: 'SecurityTextTitleText';
  json: Scalars['JSON']['output'];
  links: SecurityTextTitleTextLinks;
};

export type SecurityTextTitleTextAssets = {
  __typename?: 'SecurityTextTitleTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SecurityTextTitleTextEntries = {
  __typename?: 'SecurityTextTitleTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SecurityTextTitleTextLinks = {
  __typename?: 'SecurityTextTitleTextLinks';
  assets: SecurityTextTitleTextAssets;
  entries: SecurityTextTitleTextEntries;
  resources: SecurityTextTitleTextResources;
};

export type SecurityTextTitleTextResources = {
  __typename?: 'SecurityTextTitleTextResources';
  block: Array<SecurityTextTitleTextResourcesBlock>;
  hyperlink: Array<SecurityTextTitleTextResourcesHyperlink>;
  inline: Array<SecurityTextTitleTextResourcesInline>;
};

export type SecurityTextTitleTextResourcesBlock = ResourceLink & {
  __typename?: 'SecurityTextTitleTextResourcesBlock';
  sys: ResourceSys;
};

export type SecurityTextTitleTextResourcesHyperlink = ResourceLink & {
  __typename?: 'SecurityTextTitleTextResourcesHyperlink';
  sys: ResourceSys;
};

export type SecurityTextTitleTextResourcesInline = ResourceLink & {
  __typename?: 'SecurityTextTitleTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFields = Entry & _Node & {
  __typename?: 'SeoFields';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SeoFieldsLinkingCollections>;
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  noindex?: Maybe<Scalars['Boolean']['output']>;
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  shareImagesCollection?: Maybe<AssetCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsNofollowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsNoindexArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/seoFields) */
export type SeoFieldsShareImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SeoFieldsCollection = {
  __typename?: 'SeoFieldsCollection';
  items: Array<Maybe<SeoFields>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SeoFieldsFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoFieldsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoFieldsFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nofollow?: InputMaybe<Scalars['Boolean']['input']>;
  nofollow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nofollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  noindex_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noindex_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageDescription?: InputMaybe<Scalars['String']['input']>;
  pageDescription_contains?: InputMaybe<Scalars['String']['input']>;
  pageDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDescription_not?: InputMaybe<Scalars['String']['input']>;
  pageDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shareImagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type SeoFieldsLinkingCollections = {
  __typename?: 'SeoFieldsLinkingCollections';
  adobeSummitCollection?: Maybe<AdobeSummitCollection>;
  blogSectionCollection?: Maybe<BlogSectionCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type SeoFieldsLinkingCollectionsAdobeSummitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeoFieldsLinkingCollectionsAdobeSummitCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoFieldsLinkingCollectionsBlogSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeoFieldsLinkingCollectionsBlogSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoFieldsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum SeoFieldsLinkingCollectionsAdobeSummitCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SeoFieldsLinkingCollectionsBlogSectionCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum SeoFieldsOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  NofollowAsc = 'nofollow_ASC',
  NofollowDesc = 'nofollow_DESC',
  NoindexAsc = 'noindex_ASC',
  NoindexDesc = 'noindex_DESC',
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type Tab = Entry & _Node & {
  __typename?: 'Tab';
  _id: Scalars['ID']['output'];
  colour?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  infoItemsCollection?: Maybe<TabInfoItemsCollection>;
  linkedFrom?: Maybe<TabLinkingCollections>;
  sys: Sys;
  tabBackgroundImage?: Maybe<Asset>;
  tabDescription?: Maybe<TabTabDescription>;
  tabForegroundImage?: Maybe<Asset>;
  tabSubDescription?: Maybe<TabTabSubDescription>;
  tabTitle?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabInfoItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabInfoItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabTabBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabTabDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabTabForegroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabTabSubDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tab) */
export type TabTabTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TabCollection = {
  __typename?: 'TabCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  colour_contains?: InputMaybe<Scalars['String']['input']>;
  colour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not?: InputMaybe<Scalars['String']['input']>;
  colour_not_contains?: InputMaybe<Scalars['String']['input']>;
  colour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  infoItems?: InputMaybe<CfAccordionItemNestedFilter>;
  infoItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tabBackgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabDescription_contains?: InputMaybe<Scalars['String']['input']>;
  tabDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabForegroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabSubDescription_contains?: InputMaybe<Scalars['String']['input']>;
  tabSubDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabSubDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TabInfoItemsCollection = {
  __typename?: 'TabInfoItemsCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum TabInfoItemsCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  ItemTextAsc = 'itemText_ASC',
  ItemTextDesc = 'itemText_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TabLinkingCollections = {
  __typename?: 'TabLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  tabListCollection?: Maybe<TabListCollection>;
};


export type TabLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TabLinkingCollectionsTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsTabListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum TabLinkingCollectionsTabListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabList = Entry & _Node & {
  __typename?: 'TabList';
  _id: Scalars['ID']['output'];
  backgroundImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<TabListDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkButton?: Maybe<Entry>;
  linkedFrom?: Maybe<TabListLinkingCollections>;
  sys: Sys;
  tabsCollection?: Maybe<TabListTabsCollection>;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListLinkButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabListTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tabList) */
export type TabListVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TabListCollection = {
  __typename?: 'TabListCollection';
  items: Array<Maybe<TabList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabListDescription = {
  __typename?: 'TabListDescription';
  json: Scalars['JSON']['output'];
  links: TabListDescriptionLinks;
};

export type TabListDescriptionAssets = {
  __typename?: 'TabListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TabListDescriptionEntries = {
  __typename?: 'TabListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TabListDescriptionLinks = {
  __typename?: 'TabListDescriptionLinks';
  assets: TabListDescriptionAssets;
  entries: TabListDescriptionEntries;
  resources: TabListDescriptionResources;
};

export type TabListDescriptionResources = {
  __typename?: 'TabListDescriptionResources';
  block: Array<TabListDescriptionResourcesBlock>;
  hyperlink: Array<TabListDescriptionResourcesHyperlink>;
  inline: Array<TabListDescriptionResourcesInline>;
};

export type TabListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'TabListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type TabListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'TabListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type TabListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'TabListDescriptionResourcesInline';
  sys: ResourceSys;
};

export type TabListFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabListFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tabs?: InputMaybe<CfTabNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TabListLinkingCollections = {
  __typename?: 'TabListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type TabListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum TabListOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type TabListTabsCollection = {
  __typename?: 'TabListTabsCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum TabListTabsCollectionOrder {
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TabTitleAsc = 'tabTitle_ASC',
  TabTitleDesc = 'tabTitle_DESC'
}

export enum TabOrder {
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TabTitleAsc = 'tabTitle_ASC',
  TabTitleDesc = 'tabTitle_DESC'
}

export type TabTabDescription = {
  __typename?: 'TabTabDescription';
  json: Scalars['JSON']['output'];
  links: TabTabDescriptionLinks;
};

export type TabTabDescriptionAssets = {
  __typename?: 'TabTabDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TabTabDescriptionEntries = {
  __typename?: 'TabTabDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TabTabDescriptionLinks = {
  __typename?: 'TabTabDescriptionLinks';
  assets: TabTabDescriptionAssets;
  entries: TabTabDescriptionEntries;
  resources: TabTabDescriptionResources;
};

export type TabTabDescriptionResources = {
  __typename?: 'TabTabDescriptionResources';
  block: Array<TabTabDescriptionResourcesBlock>;
  hyperlink: Array<TabTabDescriptionResourcesHyperlink>;
  inline: Array<TabTabDescriptionResourcesInline>;
};

export type TabTabDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'TabTabDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type TabTabDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'TabTabDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type TabTabDescriptionResourcesInline = ResourceLink & {
  __typename?: 'TabTabDescriptionResourcesInline';
  sys: ResourceSys;
};

export type TabTabSubDescription = {
  __typename?: 'TabTabSubDescription';
  json: Scalars['JSON']['output'];
  links: TabTabSubDescriptionLinks;
};

export type TabTabSubDescriptionAssets = {
  __typename?: 'TabTabSubDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TabTabSubDescriptionEntries = {
  __typename?: 'TabTabSubDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TabTabSubDescriptionLinks = {
  __typename?: 'TabTabSubDescriptionLinks';
  assets: TabTabSubDescriptionAssets;
  entries: TabTabSubDescriptionEntries;
  resources: TabTabSubDescriptionResources;
};

export type TabTabSubDescriptionResources = {
  __typename?: 'TabTabSubDescriptionResources';
  block: Array<TabTabSubDescriptionResourcesBlock>;
  hyperlink: Array<TabTabSubDescriptionResourcesHyperlink>;
  inline: Array<TabTabSubDescriptionResourcesInline>;
};

export type TabTabSubDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'TabTabSubDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type TabTabSubDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'TabTabSubDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type TabTabSubDescriptionResourcesInline = ResourceLink & {
  __typename?: 'TabTabSubDescriptionResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tags) */
export type Tags = Entry & _Node & {
  __typename?: 'Tags';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TagsLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tags) */
export type TagsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/tags) */
export type TagsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCollection = {
  __typename?: 'TagsCollection';
  items: Array<Maybe<Tags>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TagsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TagsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TagsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TagsLinkingCollections = {
  __typename?: 'TagsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  profileCollection?: Maybe<ProfileCollection>;
};


export type TagsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TagsLinkingCollectionsProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TagsLinkingCollectionsProfileCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum TagsLinkingCollectionsProfileCollectionOrder {
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TagsOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTab = Entry & _Node & {
  __typename?: 'VerticalTab';
  _id: Scalars['ID']['output'];
  card2Description?: Maybe<Scalars['String']['output']>;
  card2Image?: Maybe<Asset>;
  card2Title?: Maybe<Scalars['String']['output']>;
  card3Description?: Maybe<Scalars['String']['output']>;
  card3Image?: Maybe<Asset>;
  card3Title?: Maybe<Scalars['String']['output']>;
  card4Description?: Maybe<Scalars['String']['output']>;
  card4Image?: Maybe<Asset>;
  card4Title?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  eyeBrowText?: Maybe<Scalars['String']['output']>;
  featureCardDescription?: Maybe<Scalars['String']['output']>;
  featureCardImage?: Maybe<Asset>;
  featureCardLinkText?: Maybe<Scalars['String']['output']>;
  featureCardLinkUrl?: Maybe<Scalars['String']['output']>;
  featureCardTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<VerticalTabLinkingCollections>;
  sys: Sys;
  tabTitle?: Maybe<Scalars['String']['output']>;
  videoFile2?: Maybe<Asset>;
  videoFile3?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard2DescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard2ImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard2TitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard3DescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard3ImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard3TitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard4DescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard4ImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabCard4TitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabEyeBrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabFeatureCardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabFeatureCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabFeatureCardLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabFeatureCardLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabFeatureCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabTabTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabVideoFile2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTab) */
export type VerticalTabVideoFile3Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerticalTabCollection = {
  __typename?: 'VerticalTabCollection';
  items: Array<Maybe<VerticalTab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VerticalTabFilter = {
  AND?: InputMaybe<Array<InputMaybe<VerticalTabFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VerticalTabFilter>>>;
  card2Description?: InputMaybe<Scalars['String']['input']>;
  card2Description_contains?: InputMaybe<Scalars['String']['input']>;
  card2Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Description_not?: InputMaybe<Scalars['String']['input']>;
  card2Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card2Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Title?: InputMaybe<Scalars['String']['input']>;
  card2Title_contains?: InputMaybe<Scalars['String']['input']>;
  card2Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Title_not?: InputMaybe<Scalars['String']['input']>;
  card2Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card2Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Description?: InputMaybe<Scalars['String']['input']>;
  card3Description_contains?: InputMaybe<Scalars['String']['input']>;
  card3Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Description_not?: InputMaybe<Scalars['String']['input']>;
  card3Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card3Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Title?: InputMaybe<Scalars['String']['input']>;
  card3Title_contains?: InputMaybe<Scalars['String']['input']>;
  card3Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Title_not?: InputMaybe<Scalars['String']['input']>;
  card3Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card3Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Description?: InputMaybe<Scalars['String']['input']>;
  card4Description_contains?: InputMaybe<Scalars['String']['input']>;
  card4Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Description_not?: InputMaybe<Scalars['String']['input']>;
  card4Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card4Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Title?: InputMaybe<Scalars['String']['input']>;
  card4Title_contains?: InputMaybe<Scalars['String']['input']>;
  card4Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Title_not?: InputMaybe<Scalars['String']['input']>;
  card4Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card4Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyeBrowText?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyeBrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardDescription?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardDescription_not?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkText?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkText_not?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkUrl?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardTitle?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardTitle_not?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoFile2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoFile3_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerticalTabLinkingCollections = {
  __typename?: 'VerticalTabLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  verticalTabListCollection?: Maybe<VerticalTabListCollection>;
};


export type VerticalTabLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VerticalTabLinkingCollectionsVerticalTabListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VerticalTabLinkingCollectionsVerticalTabListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum VerticalTabLinkingCollectionsVerticalTabListCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabList = Entry & _Node & {
  __typename?: 'VerticalTabList';
  _id: Scalars['ID']['output'];
  backgroundImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<VerticalTabListDescription>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkButton?: Maybe<Entry>;
  linkedFrom?: Maybe<VerticalTabListLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  verticalTabsCollection?: Maybe<VerticalTabListVerticalTabsCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListLinkButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/th24uc69tvpx/content_types/verticalTabList) */
export type VerticalTabListVerticalTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VerticalTabListVerticalTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalTabFilter>;
};

export type VerticalTabListCollection = {
  __typename?: 'VerticalTabListCollection';
  items: Array<Maybe<VerticalTabList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VerticalTabListDescription = {
  __typename?: 'VerticalTabListDescription';
  json: Scalars['JSON']['output'];
  links: VerticalTabListDescriptionLinks;
};

export type VerticalTabListDescriptionAssets = {
  __typename?: 'VerticalTabListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type VerticalTabListDescriptionEntries = {
  __typename?: 'VerticalTabListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type VerticalTabListDescriptionLinks = {
  __typename?: 'VerticalTabListDescriptionLinks';
  assets: VerticalTabListDescriptionAssets;
  entries: VerticalTabListDescriptionEntries;
  resources: VerticalTabListDescriptionResources;
};

export type VerticalTabListDescriptionResources = {
  __typename?: 'VerticalTabListDescriptionResources';
  block: Array<VerticalTabListDescriptionResourcesBlock>;
  hyperlink: Array<VerticalTabListDescriptionResourcesHyperlink>;
  inline: Array<VerticalTabListDescriptionResourcesInline>;
};

export type VerticalTabListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'VerticalTabListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type VerticalTabListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'VerticalTabListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type VerticalTabListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'VerticalTabListDescriptionResourcesInline';
  sys: ResourceSys;
};

export type VerticalTabListFilter = {
  AND?: InputMaybe<Array<InputMaybe<VerticalTabListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VerticalTabListFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verticalTabs?: InputMaybe<CfVerticalTabNestedFilter>;
  verticalTabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerticalTabListLinkingCollections = {
  __typename?: 'VerticalTabListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type VerticalTabListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum VerticalTabListOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type VerticalTabListVerticalTabsCollection = {
  __typename?: 'VerticalTabListVerticalTabsCollection';
  items: Array<Maybe<VerticalTab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum VerticalTabListVerticalTabsCollectionOrder {
  Card2DescriptionAsc = 'card2Description_ASC',
  Card2DescriptionDesc = 'card2Description_DESC',
  Card2TitleAsc = 'card2Title_ASC',
  Card2TitleDesc = 'card2Title_DESC',
  Card3DescriptionAsc = 'card3Description_ASC',
  Card3DescriptionDesc = 'card3Description_DESC',
  Card3TitleAsc = 'card3Title_ASC',
  Card3TitleDesc = 'card3Title_DESC',
  Card4DescriptionAsc = 'card4Description_ASC',
  Card4DescriptionDesc = 'card4Description_DESC',
  Card4TitleAsc = 'card4Title_ASC',
  Card4TitleDesc = 'card4Title_DESC',
  EyeBrowTextAsc = 'eyeBrowText_ASC',
  EyeBrowTextDesc = 'eyeBrowText_DESC',
  FeatureCardDescriptionAsc = 'featureCardDescription_ASC',
  FeatureCardDescriptionDesc = 'featureCardDescription_DESC',
  FeatureCardLinkTextAsc = 'featureCardLinkText_ASC',
  FeatureCardLinkTextDesc = 'featureCardLinkText_DESC',
  FeatureCardLinkUrlAsc = 'featureCardLinkUrl_ASC',
  FeatureCardLinkUrlDesc = 'featureCardLinkUrl_DESC',
  FeatureCardTitleAsc = 'featureCardTitle_ASC',
  FeatureCardTitleDesc = 'featureCardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TabTitleAsc = 'tabTitle_ASC',
  TabTitleDesc = 'tabTitle_DESC'
}

export enum VerticalTabOrder {
  Card2DescriptionAsc = 'card2Description_ASC',
  Card2DescriptionDesc = 'card2Description_DESC',
  Card2TitleAsc = 'card2Title_ASC',
  Card2TitleDesc = 'card2Title_DESC',
  Card3DescriptionAsc = 'card3Description_ASC',
  Card3DescriptionDesc = 'card3Description_DESC',
  Card3TitleAsc = 'card3Title_ASC',
  Card3TitleDesc = 'card3Title_DESC',
  Card4DescriptionAsc = 'card4Description_ASC',
  Card4DescriptionDesc = 'card4Description_DESC',
  Card4TitleAsc = 'card4Title_ASC',
  Card4TitleDesc = 'card4Title_DESC',
  EyeBrowTextAsc = 'eyeBrowText_ASC',
  EyeBrowTextDesc = 'eyeBrowText_DESC',
  FeatureCardDescriptionAsc = 'featureCardDescription_ASC',
  FeatureCardDescriptionDesc = 'featureCardDescription_DESC',
  FeatureCardLinkTextAsc = 'featureCardLinkText_ASC',
  FeatureCardLinkTextDesc = 'featureCardLinkText_DESC',
  FeatureCardLinkUrlAsc = 'featureCardLinkUrl_ASC',
  FeatureCardLinkUrlDesc = 'featureCardLinkUrl_DESC',
  FeatureCardTitleAsc = 'featureCardTitle_ASC',
  FeatureCardTitleDesc = 'featureCardTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TabTitleAsc = 'tabTitle_ASC',
  TabTitleDesc = 'tabTitle_DESC'
}

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfAccordionItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAccordionItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAccordionItemNestedFilter>>>;
  additionalItemText?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_contains?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  additionalItemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalItemText_not?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  additionalItemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemDescription_contains?: InputMaybe<Scalars['String']['input']>;
  itemDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  itemText_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText_not?: InputMaybe<Scalars['String']['input']>;
  itemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfAiContentNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAiContentNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAiContentNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyeBrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfArticleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfArticleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfArticleNestedFilter>>>;
  aiContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleType?: InputMaybe<Scalars['String']['input']>;
  articleType_contains?: InputMaybe<Scalars['String']['input']>;
  articleType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleType_not?: InputMaybe<Scalars['String']['input']>;
  articleType_not_contains?: InputMaybe<Scalars['String']['input']>;
  articleType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authors?: InputMaybe<Scalars['String']['input']>;
  authors_contains?: InputMaybe<Scalars['String']['input']>;
  authors_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authors_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authors_not?: InputMaybe<Scalars['String']['input']>;
  authors_not_contains?: InputMaybe<Scalars['String']['input']>;
  authors_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  colour_contains?: InputMaybe<Scalars['String']['input']>;
  colour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not?: InputMaybe<Scalars['String']['input']>;
  colour_not_contains?: InputMaybe<Scalars['String']['input']>;
  colour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publicationDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publicationDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription?: InputMaybe<Scalars['String']['input']>;
  subDescription_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subDescription_not?: InputMaybe<Scalars['String']['input']>;
  subDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  thumbnailImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoFile_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfAuthorNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAuthorNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAuthorNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfButtonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  buttonImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  cardBackgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  cardDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardEyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardEyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardEyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLink?: InputMaybe<Scalars['String']['input']>;
  cardLinkText?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLinkText_not?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLink_contains?: InputMaybe<Scalars['String']['input']>;
  cardLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardLink_not?: InputMaybe<Scalars['String']['input']>;
  cardLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  cardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  cardTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTitle_not?: InputMaybe<Scalars['String']['input']>;
  cardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  subDescription_contains?: InputMaybe<Scalars['String']['input']>;
  subDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFooterSectionLinksNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterSectionLinksNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterSectionLinksNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeroNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeroNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeroNestedFilter>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleRtf?: InputMaybe<Scalars['String']['input']>;
  titleRtf_contains?: InputMaybe<Scalars['String']['input']>;
  titleRtf_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleRtf_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleRtf_not?: InputMaybe<Scalars['String']['input']>;
  titleRtf_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleRtf_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfImageAndTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfImageAndTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfImageAndTextNestedFilter>>>;
  additionalText?: InputMaybe<Scalars['String']['input']>;
  additionalText_contains?: InputMaybe<Scalars['String']['input']>;
  additionalText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  additionalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalText_not?: InputMaybe<Scalars['String']['input']>;
  additionalText_not_contains?: InputMaybe<Scalars['String']['input']>;
  additionalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videofile_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  linkAltText?: InputMaybe<Scalars['String']['input']>;
  linkAltText_contains?: InputMaybe<Scalars['String']['input']>;
  linkAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkAltText_not?: InputMaybe<Scalars['String']['input']>;
  linkAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfListOfLinksNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfListOfLinksNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfListOfLinksNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfLocationCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLocationCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLocationCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  information_contains?: InputMaybe<Scalars['String']['input']>;
  information_exists?: InputMaybe<Scalars['Boolean']['input']>;
  information_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  information_not?: InputMaybe<Scalars['String']['input']>;
  information_not_contains?: InputMaybe<Scalars['String']['input']>;
  information_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfLogoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLogoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLogoNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  logoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  logoName_contains?: InputMaybe<Scalars['String']['input']>;
  logoName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoName_not?: InputMaybe<Scalars['String']['input']>;
  logoName_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_contains?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewWindow_not?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_not_contains?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrlAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrlAltText_not?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrlAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrl_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteUrl_not?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMenuItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMenuItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMenuItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  orderposition?: InputMaybe<Scalars['Int']['input']>;
  orderposition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  orderposition_gt?: InputMaybe<Scalars['Int']['input']>;
  orderposition_gte?: InputMaybe<Scalars['Int']['input']>;
  orderposition_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  orderposition_lt?: InputMaybe<Scalars['Int']['input']>;
  orderposition_lte?: InputMaybe<Scalars['Int']['input']>;
  orderposition_not?: InputMaybe<Scalars['Int']['input']>;
  orderposition_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parentItem_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfProfileNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProfileNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProfileNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_contains?: InputMaybe<Scalars['String']['input']>;
  position_exists?: InputMaybe<Scalars['Boolean']['input']>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position_not?: InputMaybe<Scalars['String']['input']>;
  position_not_contains?: InputMaybe<Scalars['String']['input']>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tagsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSeoFieldsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSeoFieldsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSeoFieldsNestedFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nofollow?: InputMaybe<Scalars['Boolean']['input']>;
  nofollow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nofollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  noindex_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noindex_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageDescription?: InputMaybe<Scalars['String']['input']>;
  pageDescription_contains?: InputMaybe<Scalars['String']['input']>;
  pageDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDescription_not?: InputMaybe<Scalars['String']['input']>;
  pageDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shareImagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfTabNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  colour_contains?: InputMaybe<Scalars['String']['input']>;
  colour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not?: InputMaybe<Scalars['String']['input']>;
  colour_not_contains?: InputMaybe<Scalars['String']['input']>;
  colour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  infoItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tabBackgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabDescription_contains?: InputMaybe<Scalars['String']['input']>;
  tabDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabForegroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabSubDescription_contains?: InputMaybe<Scalars['String']['input']>;
  tabSubDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabSubDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTagsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTagsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTagsNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfVerticalTabNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVerticalTabNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVerticalTabNestedFilter>>>;
  card2Description?: InputMaybe<Scalars['String']['input']>;
  card2Description_contains?: InputMaybe<Scalars['String']['input']>;
  card2Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Description_not?: InputMaybe<Scalars['String']['input']>;
  card2Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card2Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Title?: InputMaybe<Scalars['String']['input']>;
  card2Title_contains?: InputMaybe<Scalars['String']['input']>;
  card2Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card2Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card2Title_not?: InputMaybe<Scalars['String']['input']>;
  card2Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card2Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Description?: InputMaybe<Scalars['String']['input']>;
  card3Description_contains?: InputMaybe<Scalars['String']['input']>;
  card3Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Description_not?: InputMaybe<Scalars['String']['input']>;
  card3Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card3Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Title?: InputMaybe<Scalars['String']['input']>;
  card3Title_contains?: InputMaybe<Scalars['String']['input']>;
  card3Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card3Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card3Title_not?: InputMaybe<Scalars['String']['input']>;
  card3Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card3Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Description?: InputMaybe<Scalars['String']['input']>;
  card4Description_contains?: InputMaybe<Scalars['String']['input']>;
  card4Description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Description_not?: InputMaybe<Scalars['String']['input']>;
  card4Description_not_contains?: InputMaybe<Scalars['String']['input']>;
  card4Description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Title?: InputMaybe<Scalars['String']['input']>;
  card4Title_contains?: InputMaybe<Scalars['String']['input']>;
  card4Title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  card4Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card4Title_not?: InputMaybe<Scalars['String']['input']>;
  card4Title_not_contains?: InputMaybe<Scalars['String']['input']>;
  card4Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyeBrowText?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyeBrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeBrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyeBrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardDescription?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardDescription_not?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkText?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkText_not?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkUrl?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardTitle?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureCardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureCardTitle_not?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureCardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoFile2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoFile3_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetBatchContentOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBatchContentOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetBatchContentTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBatchContentTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetBatchContentThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBatchContentThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageBatchBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageBatchBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetBlogDetailPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetBlogDetailPageQuery = { __typename?: 'Query', pageBlogDetailPageCollection?: { __typename?: 'PageBlogDetailPageCollection', items: Array<{ __typename?: 'PageBlogDetailPage', internalName?: string | null, slug?: string | null, seoFields?: { __typename?: 'Accordion' } | { __typename?: 'AccordionItem' } | { __typename?: 'AdobeSummit' } | { __typename?: 'AiContent' } | { __typename?: 'Article' } | { __typename?: 'ArticleList' } | { __typename?: 'Author' } | { __typename?: 'Banner' } | { __typename?: 'BlogSection' } | { __typename?: 'Button' } | { __typename?: 'Card' } | { __typename?: 'CardList' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'Footer' } | { __typename?: 'FooterSectionLinks' } | { __typename?: 'Header' } | { __typename?: 'Hero' } | { __typename?: 'HeroWithCards' } | { __typename?: 'ImageAndText' } | { __typename?: 'ImageAndTextList' } | { __typename?: 'LayoutComponents' } | { __typename?: 'Link' } | { __typename?: 'LinkList' } | { __typename?: 'ListOfLinks' } | { __typename?: 'ListOfLocation' } | { __typename?: 'LocationCard' } | { __typename?: 'LocationList' } | { __typename?: 'Logo' } | { __typename?: 'LogoList' } | { __typename?: 'LottieAnimation' } | { __typename?: 'Menu' } | { __typename?: 'MenuItem' } | { __typename?: 'PageBlogDetailPage' } | { __typename?: 'PageGeneric' } | { __typename?: 'Profile' } | { __typename?: 'ProfilleData' } | { __typename?: 'SecurityText' } | (
        { __typename?: 'SeoFields' }
        & SeoFieldsFragment
      ) | { __typename?: 'Tab' } | { __typename?: 'TabList' } | { __typename?: 'Tags' } | { __typename?: 'VerticalTab' } | { __typename?: 'VerticalTabList' } | null, blog?: (
        { __typename?: 'Article' }
        & ArticleFieldsFragment
      ) | null } | null> } | null };

export type GetBlogDetailsSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogDetailsSlugsQuery = { __typename?: 'Query', pageBlogDetailPageCollection?: { __typename?: 'PageBlogDetailPageCollection', items: Array<{ __typename?: 'PageBlogDetailPage', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetAssetDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAssetDetailsQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', url?: string | null, fileName?: string | null, description?: string | null } | null };

export type GetBlogPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBlogPageQuery = { __typename?: 'Query', blogSection?: { __typename?: 'BlogSection', internalName?: string | null, eyebrowText?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, seoFields?: (
      { __typename?: 'SeoFields' }
      & SeoFieldsFragment
    ) | null, backgroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, featuredBlog?: (
      { __typename?: 'Article' }
      & ArticleFieldsFragment
    ) | null } | null };

export type GetBlogSectionIDsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogSectionIDsQuery = { __typename?: 'Query', blogSectionCollection?: { __typename?: 'BlogSectionCollection', items: Array<{ __typename?: 'BlogSection', title?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetDesktopOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDesktopOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetDesktopTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDesktopTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetDesktopThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDesktopThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageDesktopBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageDesktopBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetEnterprisePageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEnterprisePageOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListIconFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetEnterprisePageTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEnterprisePageTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | (
        { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } }
        & AccordionItemFieldsFragment
      ) | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } }
        & VerticalTabListFieldsFragment
      ) | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageEnterpriseBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageEnterpriseBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetEventLandingOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEventLandingOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } }
        & VerticalTabListFieldsFragment
      ) | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetEventLandingTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEventLandingTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetEventLandingThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEventLandingThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } }
        & ProfilleDataFieldsFragment
      ) | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageSiteBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageSiteBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetTextPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTextPageQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } }
        & SecurityTextFragmentFragment
      ) | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetIndustryPageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetIndustryPageOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetIndustryPageTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIndustryPageTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | (
        { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } }
        & AccordionItemFieldsFragment
      ) | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetHomePageBasicComponentsQueryVariables = Exact<{
  componentsLimit?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomePageBasicComponentsQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', internalName?: string | null, sys: { __typename?: 'Sys', id: string }, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion' } | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | { __typename: 'ArticleList' } | { __typename: 'Author' } | { __typename: 'Banner' } | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | { __typename: 'CardList' } | (
          { __typename: 'ContentTile' }
          & ContentTileFieldsFragment
        ) | { __typename: 'ContentTypeRichText' } | { __typename: 'Footer' } | { __typename: 'FooterSectionLinks' } | { __typename: 'Header' } | (
          { __typename: 'Hero' }
          & HeroFieldsFragment
        ) | { __typename: 'HeroWithCards' } | { __typename: 'ImageAndText' } | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | (
          { __typename: 'LogoList' }
          & LogoListFieldsFragment
        ) | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | { __typename: 'SeoFields' } | { __typename: 'Tab' } | { __typename: 'TabList' } | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | { __typename: 'VerticalTabList' } | null> } | null } | null> } | null };

export type GetHomePageListComponentsQueryVariables = Exact<{
  componentsLimit?: InputMaybe<Scalars['Int']['input']>;
  articleListLimit?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomePageListComponentsQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', sys: { __typename?: 'Sys', id: string }, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion' } | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | (
          { __typename: 'ArticleList' }
          & ArticleListFieldsFragment
        ) | { __typename: 'Author' } | { __typename: 'Banner' } | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | { __typename: 'CardList' } | { __typename: 'ContentTile' } | { __typename: 'ContentTypeRichText' } | { __typename: 'Footer' } | { __typename: 'FooterSectionLinks' } | { __typename: 'Header' } | { __typename: 'Hero' } | (
          { __typename: 'HeroWithCards' }
          & HeroWithCardsFieldsFragment
        ) | (
          { __typename: 'ImageAndText' }
          & ImageAndTextFieldsFragment
        ) | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | { __typename: 'LogoList' } | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | { __typename: 'SeoFields' } | { __typename: 'Tab' } | { __typename: 'TabList' } | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | { __typename: 'VerticalTabList' } | null> } | null } | null> } | null };

export type GetHomePageNavComponentsQueryVariables = Exact<{
  componentsLimit?: InputMaybe<Scalars['Int']['input']>;
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomePageNavComponentsQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', sys: { __typename?: 'Sys', id: string }, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion' } | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | { __typename: 'ArticleList' } | { __typename: 'Author' } | { __typename: 'Banner' } | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | { __typename: 'CardList' } | { __typename: 'ContentTile' } | { __typename: 'ContentTypeRichText' } | { __typename: 'Footer' } | { __typename: 'FooterSectionLinks' } | { __typename: 'Header' } | { __typename: 'Hero' } | { __typename: 'HeroWithCards' } | { __typename: 'ImageAndText' } | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | { __typename: 'LogoList' } | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | { __typename: 'SeoFields' } | { __typename: 'Tab' } | (
          { __typename: 'TabList' }
          & TabListFieldsFragment
        ) | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | (
          { __typename: 'VerticalTabList' }
          & VerticalTabListFieldsFragment
        ) | null> } | null } | null> } | null };

export type GetHomePageCardComponentsQueryVariables = Exact<{
  componentsLimit?: InputMaybe<Scalars['Int']['input']>;
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomePageCardComponentsQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', sys: { __typename?: 'Sys', id: string }, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
          { __typename: 'Accordion' }
          & AccordionFieldsFragment
        ) | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | { __typename: 'ArticleList' } | { __typename: 'Author' } | { __typename: 'Banner' } | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | (
          { __typename: 'CardList' }
          & CardListFieldsFragment
        ) | { __typename: 'ContentTile' } | { __typename: 'ContentTypeRichText' } | { __typename: 'Footer' } | { __typename: 'FooterSectionLinks' } | { __typename: 'Header' } | { __typename: 'Hero' } | { __typename: 'HeroWithCards' } | { __typename: 'ImageAndText' } | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | { __typename: 'LogoList' } | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | { __typename: 'SeoFields' } | { __typename: 'Tab' } | { __typename: 'TabList' } | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | { __typename: 'VerticalTabList' } | null> } | null } | null> } | null };

export type GetHomePageSeoQueryVariables = Exact<{
  internalName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHomePageSeoQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', sys: { __typename?: 'Sys', id: string }, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion' } | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | { __typename: 'ArticleList' } | { __typename: 'Author' } | { __typename: 'Banner' } | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | { __typename: 'CardList' } | { __typename: 'ContentTile' } | { __typename: 'ContentTypeRichText' } | { __typename: 'Footer' } | { __typename: 'FooterSectionLinks' } | { __typename: 'Header' } | { __typename: 'Hero' } | { __typename: 'HeroWithCards' } | { __typename: 'ImageAndText' } | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | { __typename: 'LogoList' } | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | (
          { __typename: 'SeoFields' }
          & SeoFieldsFragment
        ) | { __typename: 'Tab' } | { __typename: 'TabList' } | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | { __typename: 'VerticalTabList' } | null> } | null } | null> } | null };

export type GetLayoutComponentsQueryVariables = Exact<{
  componentsLimit?: InputMaybe<Scalars['Int']['input']>;
  navigationLinksLimit?: InputMaybe<Scalars['Int']['input']>;
  callToActionLimit?: InputMaybe<Scalars['Int']['input']>;
  linksLimit?: InputMaybe<Scalars['Int']['input']>;
  socialMediaLinksLimit?: InputMaybe<Scalars['Int']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLayoutComponentsQuery = { __typename?: 'Query', layoutComponentsCollection?: { __typename?: 'LayoutComponentsCollection', items: Array<{ __typename?: 'LayoutComponents', internalName?: string | null, componentsCollection?: { __typename?: 'LayoutComponentsComponentsCollection', items: Array<{ __typename: 'Accordion' } | { __typename: 'AccordionItem' } | { __typename: 'AdobeSummit' } | { __typename: 'AiContent' } | { __typename: 'Article' } | { __typename: 'ArticleList' } | { __typename: 'Author' } | (
          { __typename: 'Banner' }
          & BannerFragmentFragment
        ) | { __typename: 'BlogSection' } | { __typename: 'Button' } | { __typename: 'Card' } | { __typename: 'CardList' } | { __typename: 'ContentTile' } | { __typename: 'ContentTypeRichText' } | (
          { __typename: 'Footer' }
          & FooterFieldsFragment
        ) | { __typename: 'FooterSectionLinks' } | (
          { __typename: 'Header' }
          & HeaderFieldsFragment
        ) | { __typename: 'Hero' } | { __typename: 'HeroWithCards' } | (
          { __typename: 'ImageAndText' }
          & ImageAndTextFieldsFragment
        ) | { __typename: 'ImageAndTextList' } | { __typename: 'LayoutComponents' } | { __typename: 'Link' } | { __typename: 'LinkList' } | { __typename: 'ListOfLinks' } | { __typename: 'ListOfLocation' } | { __typename: 'LocationCard' } | { __typename: 'LocationList' } | { __typename: 'Logo' } | { __typename: 'LogoList' } | { __typename: 'LottieAnimation' } | { __typename: 'Menu' } | { __typename: 'MenuItem' } | { __typename: 'PageBlogDetailPage' } | { __typename: 'PageGeneric' } | { __typename: 'Profile' } | { __typename: 'ProfilleData' } | { __typename: 'SecurityText' } | { __typename: 'SeoFields' } | { __typename: 'Tab' } | { __typename: 'TabList' } | { __typename: 'Tags' } | { __typename: 'VerticalTab' } | { __typename: 'VerticalTabList' } | null> } | null } | null> } | null };

export type GetMenuIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenuIdQuery = { __typename?: 'Query', menuCollection?: { __typename?: 'MenuCollection', items: Array<{ __typename?: 'Menu', name?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetMenuQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type GetMenuQuery = { __typename?: 'Query', menu?: { __typename?: 'Menu', name?: string | null, sys: { __typename?: 'Sys', id: string }, menuItemsCollection?: { __typename?: 'MenuMenuItemsCollection', items: Array<(
        { __typename?: 'MenuItem' }
        & MenuItemFieldsFragment
      ) | null> } | null } | null };

export type GetMenuItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenuItemsQuery = { __typename?: 'Query', menuItemCollection?: { __typename?: 'MenuItemCollection', items: Array<(
      { __typename?: 'MenuItem' }
      & MenuItemFieldsFragment
    ) | null> } | null };

export type GetSubMenuItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubMenuItemsQuery = { __typename?: 'Query', menuItemCollection?: { __typename?: 'MenuItemCollection', items: Array<(
      { __typename?: 'MenuItem' }
      & MenuItemFieldsFragment
    ) | null> } | null };

export type GetOmniChannelOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOmniChannelOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetOmniChannelTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOmniChannelTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetOmniChannelThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOmniChannelThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageOmniBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageOmniBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetPartnerPageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPartnerPageOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } }
        & HeroFieldsFragment
      ) | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPagePartnerBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPagePartnerBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetProductPageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductPageOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListIconFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetProductPageTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductPageTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | (
        { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } }
        & AccordionItemFieldsFragment
      ) | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageProductBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetSiteScoreOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSiteScoreOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetSiteScoreTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSiteScoreTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetSiteScoreThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSiteScoreThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPageSummitBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageSummitBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetSummitPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSummitPageQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } }
        & HeroFieldsFragment
      ) | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } }
        & ListOfLocationFragmentFragment
      ) | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetAdobePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdobePageQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } }
        & AdobeSummitFragmentFragment
      ) | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetTaskInitiationtOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTaskInitiationtOneQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } }
        & CardListFieldsFragment
      ) | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextFieldsFragment
      ) | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetTaskInitiationtTwoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTaskInitiationtTwoQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } }
        & ImageAndTextListFragmentFragment
      ) | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } }
        & LogoListFieldsFragment
      ) | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetTaskInitiationtThreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  infoLimit?: InputMaybe<Scalars['Int']['input']>;
  accordionItemLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTaskInitiationtThreeQuery = { __typename?: 'Query', pageGeneric?: { __typename?: 'PageGeneric', internalName?: string | null, componentsCollection?: { __typename?: 'PageGenericComponentsCollection', items: Array<(
        { __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } }
        & AccordionFieldsFragment
      ) | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'SeoFields', sys: { __typename?: 'Sys', id: string } }
        & SeoFieldsFragment
      ) | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } } | (
        { __typename: 'TabList', sys: { __typename?: 'Sys', id: string } }
        & TabListFieldsFragment
      ) | { __typename: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetPagetaskBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPagetaskBySlugQuery = { __typename?: 'Query', pageGenericCollection?: { __typename?: 'PageGenericCollection', items: Array<{ __typename?: 'PageGeneric', slug?: string | null, internalName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type ButtonFieldsFragment = { __typename?: 'Button', buttonText?: string | null, buttonLink?: string | null, buttonType?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, buttonImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type AssetFieldsFragment = { __typename?: 'Asset', url?: string | null, title?: string | null };

export type AccordionItemFieldsFragment = { __typename?: 'AccordionItem', internalName?: string | null, itemText?: string | null, additionalItemText?: string | null, linkText?: string | null, linkUrl?: string | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, itemDescriptionJson?: { __typename?: 'AccordionItemItemDescription', json: any } | null };

export type AccordionIconItemFieldsFragment = { __typename?: 'AccordionItem', internalName?: string | null, itemText?: string | null, sys: { __typename?: 'Sys', id: string }, itemDescriptionJson?: { __typename?: 'AccordionItemItemDescription', json: any } | null, icon?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type AccordionFieldsFragment = { __typename?: 'Accordion', variant?: string | null, internalName?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, descriptionJson?: { __typename?: 'AccordionDescription', json: any } | null, image?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, backgroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, accordionItemsCollection?: { __typename?: 'AccordionAccordionItemsCollection', items: Array<(
      { __typename?: 'AccordionItem' }
      & AccordionItemFieldsFragment
    ) | null> } | null };

export type ArticleFieldsFragment = { __typename?: 'Article', colour?: string | null, eyebrowText?: string | null, title?: string | null, subDescription?: string | null, slug?: string | null, articleType?: string | null, publicationDate?: any | null, authors?: string | null, sys: { __typename?: 'Sys', id: string }, articledescriptionJson?: { __typename?: 'ArticleDescription', json: any } | null, thumbnailImage?: { __typename?: 'Asset', url?: string | null, fileName?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null, mainImage?: { __typename?: 'Asset', url?: string | null, fileName?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null, videoFile?: { __typename?: 'Asset', url?: string | null, fileName?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null, articleLink?: (
    { __typename?: 'Link' }
    & LinkFieldsFragment
  ) | null, socialMediaLinksCollection?: { __typename?: 'ArticleSocialMediaLinksCollection', items: Array<(
      { __typename?: 'Link' }
      & LinkFieldsFragment
    ) | null> } | null, author?: (
    { __typename?: 'Author' }
    & AuthorFieldsFragment
  ) | null, linkList?: (
    { __typename?: 'ListOfLinks' }
    & ListOfLinksFieldsFragment
  ) | null, aiContent?: { __typename?: 'AiContent', eyeBrowText?: string | null, title?: string | null, description?: string | null } | null };

export type ArticleListFieldsFragment = { __typename?: 'ArticleList', internalName?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, articleListDescriptionJson?: { __typename?: 'ArticleListDescription', json: any } | null, articlesCollection?: { __typename?: 'ArticleListArticlesCollection', items: Array<(
      { __typename?: 'Article' }
      & ArticleFieldsFragment
    ) | null> } | null, button?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null };

export type CardFieldsFragment = { __typename?: 'Card', cardTitle?: string | null, cardLink?: string | null, cardLinkText?: string | null, cardEyebrowText?: string | null, sys: { __typename?: 'Sys', id: string }, cardIcon?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, cardDescription?: { __typename?: 'CardCardDescription', json: any } | null, subDescription?: { __typename?: 'CardSubDescription', json: any } | null, cardImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, cardBackgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type CardFieldInfoFragment = { __typename?: 'Card', cardTitle?: string | null, sys: { __typename?: 'Sys', id: string }, cardDescription?: { __typename?: 'CardCardDescription', json: any } | null };

export type CardListFieldsFragment = { __typename?: 'CardList', variant?: string | null, internalName?: string | null, eyebrowText?: string | null, title?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string }, cardsCollection?: { __typename?: 'CardListCardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardFieldsFragment
    ) | null> } | null };

export type HeroFieldsFragment = { __typename?: 'Hero', internalName?: string | null, title?: string | null, titleRtf?: string | null, sys: { __typename?: 'Sys', id: string }, heroFieldDescriptionJson?: { __typename?: 'HeroDescription', json: any } | null, heroImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, primaryButton?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null, secondaryButton?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null };

export type HeroWithCardsFieldsFragment = { __typename?: 'HeroWithCards', internalName?: string | null, eyebrowText?: string | null, heroTitle?: string | null, sys: { __typename?: 'Sys', id: string }, heroDescriptionJson?: { __typename?: 'HeroWithCardsDescription', json: any } | null, buttonLink?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null, foregroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, titleIcon?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, cardsCollection?: { __typename?: 'HeroWithCardsCardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardFieldsFragment
    ) | null> } | null };

export type ImageAndTextFieldsFragment = { __typename?: 'ImageAndText', internalName?: string | null, eyebrowText?: string | null, title?: string | null, additionalText?: string | null, variant?: string | null, sys: { __typename?: 'Sys', id: string }, imageDescriptionJson?: { __typename?: 'ImageAndTextDescription', json: any } | null, buttonLink?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null, image?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, videofile?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type LinkFieldsFragment = { __typename?: 'Link', linkText?: string | null, linkUrl?: string | null, openInNewWindow?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, linkIcon?: { __typename?: 'Asset', url?: string | null, title?: string | null, description?: string | null } | null };

export type LogoFieldsFragment = { __typename?: 'Logo', logoName?: string | null, websiteUrl?: string | null, websiteUrlAltText?: string | null, openInNewWindow?: string | null, sys: { __typename?: 'Sys', id: string }, logoImage?: { __typename?: 'Asset', url?: string | null, title?: string | null, imageDescriptionJson?: string | null } | null };

export type LogoListFieldsFragment = { __typename?: 'LogoList', variant?: string | null, internalName?: string | null, eyebrowText?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, descriptionJson?: { __typename?: 'LogoListDescription', json: any } | null, logosCollection?: { __typename?: 'LogoListLogosCollection', items: Array<(
      { __typename?: 'Logo' }
      & LogoFieldsFragment
    ) | null> } | null, logoListButton?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null };

export type TabFieldsFragment = { __typename?: 'Tab', colour?: string | null, tabTitle?: string | null, sys: { __typename?: 'Sys', id: string }, tabDescription?: { __typename?: 'TabTabDescription', json: any } | null, tabBackgroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null, description?: string | null } | null, tabForegroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null, description?: string | null } | null, tabSubDescription?: { __typename?: 'TabTabSubDescription', json: any } | null, infoItemsCollection?: { __typename?: 'TabInfoItemsCollection', items: Array<(
      { __typename?: 'AccordionItem' }
      & AccordionItemFieldsFragment
    ) | null> } | null };

export type TabIconFieldsFragment = { __typename?: 'Tab', tabTitle?: string | null, sys: { __typename?: 'Sys', id: string }, tabDescription?: { __typename?: 'TabTabDescription', json: any } | null, tabForegroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null, description?: string | null } | null, tabSubDescription?: { __typename?: 'TabTabSubDescription', json: any } | null, infoItemsCollection?: { __typename?: 'TabInfoItemsCollection', items: Array<(
      { __typename?: 'AccordionItem' }
      & AccordionIconItemFieldsFragment
    ) | null> } | null };

export type TabListFieldsFragment = { __typename?: 'TabList', variant?: string | null, internalName?: string | null, eyebrowText?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, backgroundImage?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, tabListdescriptionJson?: { __typename?: 'TabListDescription', json: any } | null, linkButton?: { __typename?: 'Accordion' } | { __typename?: 'AccordionItem' } | { __typename?: 'AdobeSummit' } | { __typename?: 'AiContent' } | { __typename?: 'Article' } | { __typename?: 'ArticleList' } | { __typename?: 'Author' } | { __typename?: 'Banner' } | { __typename?: 'BlogSection' } | (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | { __typename?: 'Card' } | { __typename?: 'CardList' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'Footer' } | { __typename?: 'FooterSectionLinks' } | { __typename?: 'Header' } | { __typename?: 'Hero' } | { __typename?: 'HeroWithCards' } | { __typename?: 'ImageAndText' } | { __typename?: 'ImageAndTextList' } | { __typename?: 'LayoutComponents' } | { __typename?: 'Link' } | { __typename?: 'LinkList' } | { __typename?: 'ListOfLinks' } | { __typename?: 'ListOfLocation' } | { __typename?: 'LocationCard' } | { __typename?: 'LocationList' } | { __typename?: 'Logo' } | { __typename?: 'LogoList' } | { __typename?: 'LottieAnimation' } | { __typename?: 'Menu' } | { __typename?: 'MenuItem' } | { __typename?: 'PageBlogDetailPage' } | { __typename?: 'PageGeneric' } | { __typename?: 'Profile' } | { __typename?: 'ProfilleData' } | { __typename?: 'SecurityText' } | { __typename?: 'SeoFields' } | { __typename?: 'Tab' } | { __typename?: 'TabList' } | { __typename?: 'Tags' } | { __typename?: 'VerticalTab' } | { __typename?: 'VerticalTabList' } | null, tabsCollection?: { __typename?: 'TabListTabsCollection', items: Array<(
      { __typename?: 'Tab' }
      & TabFieldsFragment
    ) | null> } | null };

export type TabListIconFieldsFragment = { __typename?: 'TabList', internalName?: string | null, eyebrowText?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, tabListdescriptionJson?: { __typename?: 'TabListDescription', json: any } | null, linkButton?: { __typename?: 'Accordion' } | { __typename?: 'AccordionItem' } | { __typename?: 'AdobeSummit' } | { __typename?: 'AiContent' } | { __typename?: 'Article' } | { __typename?: 'ArticleList' } | { __typename?: 'Author' } | { __typename?: 'Banner' } | { __typename?: 'BlogSection' } | (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | { __typename?: 'Card' } | { __typename?: 'CardList' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'Footer' } | { __typename?: 'FooterSectionLinks' } | { __typename?: 'Header' } | { __typename?: 'Hero' } | { __typename?: 'HeroWithCards' } | { __typename?: 'ImageAndText' } | { __typename?: 'ImageAndTextList' } | { __typename?: 'LayoutComponents' } | { __typename?: 'Link' } | { __typename?: 'LinkList' } | { __typename?: 'ListOfLinks' } | { __typename?: 'ListOfLocation' } | { __typename?: 'LocationCard' } | { __typename?: 'LocationList' } | { __typename?: 'Logo' } | { __typename?: 'LogoList' } | { __typename?: 'LottieAnimation' } | { __typename?: 'Menu' } | { __typename?: 'MenuItem' } | { __typename?: 'PageBlogDetailPage' } | { __typename?: 'PageGeneric' } | { __typename?: 'Profile' } | { __typename?: 'ProfilleData' } | { __typename?: 'SecurityText' } | { __typename?: 'SeoFields' } | { __typename?: 'Tab' } | { __typename?: 'TabList' } | { __typename?: 'Tags' } | { __typename?: 'VerticalTab' } | { __typename?: 'VerticalTabList' } | null, tabsCollection?: { __typename?: 'TabListTabsCollection', items: Array<(
      { __typename?: 'Tab' }
      & TabIconFieldsFragment
    ) | null> } | null };

export type HeaderFieldsFragment = { __typename?: 'Header', internalName?: string | null, sys: { __typename?: 'Sys', id: string }, logoCollection?: { __typename?: 'HeaderLogoCollection', items: Array<(
      { __typename?: 'Logo' }
      & LogoFieldsFragment
    ) | null> } | null, navigationLinksCollection?: { __typename?: 'HeaderNavigationLinksCollection', items: Array<(
      { __typename?: 'Link' }
      & LinkFieldsFragment
    ) | null> } | null, callToActionCollection?: { __typename?: 'HeaderCallToActionCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFieldsFragment
    ) | null> } | null };

export type FooterFieldsFragment = { __typename?: 'Footer', internalName?: string | null, copyrightText?: string | null, sys: { __typename?: 'Sys', id: string }, logo?: (
    { __typename?: 'Logo' }
    & LogoFieldsFragment
  ) | null, footerLinksCollection?: { __typename?: 'FooterFooterLinksCollection', items: Array<{ __typename?: 'FooterSectionLinks', heading?: string | null, linksCollection?: { __typename?: 'FooterSectionLinksLinksCollection', items: Array<(
          { __typename?: 'Link' }
          & LinkFieldsFragment
        ) | null> } | null } | null> } | null, socialMediaLinksCollection?: { __typename?: 'FooterSocialMediaLinksCollection', items: Array<(
      { __typename?: 'Link' }
      & LinkFieldsFragment
    ) | null> } | null };

export type SeoFieldsFragment = { __typename?: 'SeoFields', internalName?: string | null, pageTitle?: string | null, pageDescription?: string | null, canonicalUrl?: string | null, nofollow?: boolean | null, noindex?: boolean | null, sys: { __typename?: 'Sys', id: string }, shareImagesCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', url?: string | null, fileName?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type MenuItemFieldsFragment = { __typename?: 'MenuItem', title?: string | null, slug?: string | null, orderposition?: number | null, openInNewTab?: boolean | null, description?: string | null, sys: { __typename?: 'Sys', id: string }, parentItem?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AdobeSummit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AiContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArticleList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banner', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Card', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CardList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ContentTile', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterSectionLinks', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroWithCards', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageAndText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageAndTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LayoutComponents', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LinkList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ListOfLinks', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ListOfLocation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LocationCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LocationList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Logo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Menu', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageBlogDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageGeneric', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Profile', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProfilleData', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecurityText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoFields', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Tab', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Tags', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'VerticalTab', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'VerticalTabList', sys: { __typename?: 'Sys', id: string } } | null, linkText?: (
    { __typename?: 'Link' }
    & LinkFieldsFragment
  ) | null, icon?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type MenuFieldsFragment = { __typename?: 'Menu', name?: string | null, sys: { __typename?: 'Sys', id: string }, menuItemsCollection?: { __typename?: 'MenuMenuItemsCollection', items: Array<(
      { __typename?: 'MenuItem' }
      & MenuItemFieldsFragment
    ) | null> } | null };

export type PageBlogDetailPageFieldsFragment = { __typename?: 'PageBlogDetailPage', slug?: string | null, internalName?: string | null, type?: string | null, sys: { __typename?: 'Sys', id: string } };

export type BlogSectionFieldsFragment = { __typename?: 'BlogSection', internalName?: string | null, type?: string | null, sys: { __typename?: 'Sys', id: string } };

export type ContentTileFieldsFragment = { __typename?: 'ContentTile', title?: string | null, sys: { __typename?: 'Sys', id: string }, text?: { __typename?: 'ContentTileText', json: any } | null, image?: { __typename?: 'Asset', url?: string | null, description?: string | null } | null };

export type VerticalTabListFieldsFragment = { __typename?: 'VerticalTabList', internalName?: string | null, eyebrowText?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string }, backgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null, verticaltabListdescriptionJson?: { __typename?: 'VerticalTabListDescription', json: any } | null, linkButton?: { __typename?: 'Accordion' } | { __typename?: 'AccordionItem' } | { __typename?: 'AdobeSummit' } | { __typename?: 'AiContent' } | { __typename?: 'Article' } | { __typename?: 'ArticleList' } | { __typename?: 'Author' } | { __typename?: 'Banner' } | { __typename?: 'BlogSection' } | (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | { __typename?: 'Card' } | { __typename?: 'CardList' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'Footer' } | { __typename?: 'FooterSectionLinks' } | { __typename?: 'Header' } | { __typename?: 'Hero' } | { __typename?: 'HeroWithCards' } | { __typename?: 'ImageAndText' } | { __typename?: 'ImageAndTextList' } | { __typename?: 'LayoutComponents' } | { __typename?: 'Link' } | { __typename?: 'LinkList' } | { __typename?: 'ListOfLinks' } | { __typename?: 'ListOfLocation' } | { __typename?: 'LocationCard' } | { __typename?: 'LocationList' } | { __typename?: 'Logo' } | { __typename?: 'LogoList' } | { __typename?: 'LottieAnimation' } | { __typename?: 'Menu' } | { __typename?: 'MenuItem' } | { __typename?: 'PageBlogDetailPage' } | { __typename?: 'PageGeneric' } | { __typename?: 'Profile' } | { __typename?: 'ProfilleData' } | { __typename?: 'SecurityText' } | { __typename?: 'SeoFields' } | { __typename?: 'Tab' } | { __typename?: 'TabList' } | { __typename?: 'Tags' } | { __typename?: 'VerticalTab' } | { __typename?: 'VerticalTabList' } | null, verticalTabsCollection?: { __typename?: 'VerticalTabListVerticalTabsCollection', items: Array<(
      { __typename?: 'VerticalTab' }
      & VerticalTabFieldsFragment
    ) | null> } | null };

export type VerticalTabFieldsFragment = { __typename?: 'VerticalTab', eyeBrowText?: string | null, tabTitle?: string | null, featureCardTitle?: string | null, featureCardDescription?: string | null, featureCardLinkText?: string | null, featureCardLinkUrl?: string | null, card2Title?: string | null, card2Description?: string | null, card3Title?: string | null, card3Description?: string | null, card4Title?: string | null, card4Description?: string | null, sys: { __typename?: 'Sys', id: string }, featureCardImage?: { __typename?: 'Asset', url?: string | null } | null, videoFile2?: { __typename?: 'Asset', url?: string | null } | null, videoFile3?: { __typename?: 'Asset', url?: string | null } | null, card2Image?: { __typename?: 'Asset', url?: string | null } | null, card3Image?: { __typename?: 'Asset', url?: string | null } | null, card4Image?: { __typename?: 'Asset', url?: string | null } | null };

export type AuthorFieldsFragment = { __typename?: 'Author', name?: string | null, title?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', url?: string | null } | null };

export type ImageAndTextListFragmentFragment = { __typename?: 'ImageAndTextList', title?: string | null, eyebrowText?: string | null, sys: { __typename?: 'Sys', id: string }, imageAndTextListCollection?: { __typename?: 'ImageAndTextListImageAndTextListCollection', items: Array<(
      { __typename?: 'ImageAndText' }
      & ImageAndTextFragmentFragment
    ) | null> } | null };

export type ImageAndTextFragmentFragment = { __typename?: 'ImageAndText', title?: string | null, eyebrowText?: string | null, sys: { __typename?: 'Sys', id: string }, buttonLink?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null, videofile?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, image?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, description?: { __typename?: 'ImageAndTextDescription', json: any } | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & AssetFieldsFragment
  ) | null };

export type ListOfLinksFieldsFragment = { __typename?: 'ListOfLinks', sys: { __typename?: 'Sys', id: string }, linkListCollection?: { __typename?: 'ListOfLinksLinkListCollection', items: Array<(
      { __typename?: 'Link' }
      & LinkFieldsFragment
    ) | null> } | null };

export type ListOfLocationFragmentFragment = { __typename?: 'ListOfLocation', sys: { __typename?: 'Sys', id: string }, listOfLocationCollection?: { __typename?: 'ListOfLocationListOfLocationCollection', items: Array<{ __typename?: 'LocationCard', title?: string | null, information?: string | null, sys: { __typename?: 'Sys', id: string }, icon?: (
        { __typename?: 'Link' }
        & LinkFieldsFragment
      ) | null } | null> } | null };

export type SecurityTextFragmentFragment = { __typename?: 'SecurityText', title?: string | null, titleText?: { __typename?: 'SecurityTextTitleText', json: any } | null, text?: { __typename?: 'SecurityTextText', json: any } | null, banner?: { __typename?: 'Asset', url?: string | null, title?: string | null, description?: string | null } | null, sys: { __typename?: 'Sys', id: string } };

export type AdobeSummitFragmentFragment = { __typename?: 'AdobeSummit', title?: string | null, description?: { __typename?: 'AdobeSummitDescription', json: any } | null, banner?: (
    { __typename?: 'Hero' }
    & HeroFieldsFragment
  ) | null, primaryButton?: (
    { __typename?: 'Button' }
    & ButtonFieldsFragment
  ) | null, cardCollection?: { __typename?: 'AdobeSummitCardCollection', items: Array<(
      { __typename?: 'Card' }
      & CardFieldsFragment
    ) | null> } | null, seoFields?: (
    { __typename?: 'SeoFields' }
    & SeoFieldsFragment
  ) | null, sys: { __typename?: 'Sys', id: string } };

export type BannerFragmentFragment = { __typename?: 'Banner', title?: string | null, sys: { __typename?: 'Sys', id: string }, link?: (
    { __typename?: 'Link' }
    & LinkFieldsFragment
  ) | null, icon?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null };

export type GetAuthorDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAuthorDetailsQuery = { __typename?: 'Query', author?: (
    { __typename?: 'Author' }
    & AuthorFieldsFragment
  ) | null };

export type TagsFieldsFragment = { __typename?: 'Tags', title?: string | null };

export type ProfileFieldsFragment = { __typename?: 'Profile', title?: string | null, position?: string | null, image?: { __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null, logo?: { __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null, tagsCollection?: { __typename?: 'ProfileTagsCollection', items: Array<(
      { __typename?: 'Tags', sys: { __typename?: 'Sys', id: string } }
      & TagsFieldsFragment
    ) | null> } | null };

export type ProfilleDataFieldsFragment = { __typename?: 'ProfilleData', title?: string | null, description?: string | null, profileCollection?: { __typename?: 'ProfilleDataProfileCollection', items: Array<(
      { __typename?: 'Profile', sys: { __typename?: 'Sys', id: string } }
      & ProfileFieldsFragment
    ) | null> } | null };

export type GetArticlesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetArticlesQuery = { __typename?: 'Query', articleCollection?: { __typename?: 'ArticleCollection', items: Array<(
      { __typename?: 'Article' }
      & ArticleFieldsFragment
    ) | null> } | null };

export type GetContentTileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentTileQuery = { __typename?: 'Query', contentTileCollection?: { __typename?: 'ContentTileCollection', items: Array<(
      { __typename?: 'ContentTile' }
      & ContentTileFieldsFragment
    ) | null> } | null };

export const AccordionItemFieldsFragmentDoc = gql`
    fragment AccordionItemFields on AccordionItem {
  sys {
    id
  }
  internalName
  itemText
  additionalItemText
  icon {
    url
    title
  }
  linkText
  linkUrl
  itemDescriptionJson: itemDescription {
    json
  }
}
    `;
export const AccordionFieldsFragmentDoc = gql`
    fragment AccordionFields on Accordion {
  sys {
    id
  }
  variant
  internalName
  title
  descriptionJson: description {
    json
  }
  image {
    url
    title
  }
  backgroundImage {
    url
    title
  }
  accordionItemsCollection(limit: $accordionItemLimit) {
    items {
      ...AccordionItemFields
    }
  }
}
    `;
export const LinkFieldsFragmentDoc = gql`
    fragment LinkFields on Link {
  sys {
    id
  }
  linkText
  linkUrl
  openInNewWindow
  linkIcon {
    url
    title
    description
  }
}
    `;
export const AuthorFieldsFragmentDoc = gql`
    fragment AuthorFields on Author {
  sys {
    id
  }
  name
  title
  image {
    url
  }
  description
}
    `;
export const ListOfLinksFieldsFragmentDoc = gql`
    fragment ListOfLinksFields on ListOfLinks {
  sys {
    id
  }
  linkListCollection {
    items {
      ...LinkFields
    }
  }
}
    `;
export const ArticleFieldsFragmentDoc = gql`
    fragment ArticleFields on Article {
  sys {
    id
  }
  colour
  eyebrowText
  title
  subDescription
  slug
  articleType
  articledescriptionJson: description {
    json
  }
  thumbnailImage {
    sys {
      id
    }
    url
    fileName
    description
  }
  mainImage {
    sys {
      id
    }
    url
    fileName
    description
  }
  videoFile {
    sys {
      id
    }
    url
    fileName
    description
  }
  publicationDate
  authors
  articleLink {
    ...LinkFields
  }
  socialMediaLinksCollection {
    items {
      ...LinkFields
    }
  }
  author {
    ...AuthorFields
  }
  linkList {
    ...ListOfLinksFields
  }
  aiContent {
    eyeBrowText
    title
    description
  }
}
    `;
export const AssetFieldsFragmentDoc = gql`
    fragment AssetFields on Asset {
  url
  title
}
    `;
export const ButtonFieldsFragmentDoc = gql`
    fragment ButtonFields on Button {
  sys {
    id
  }
  buttonText
  buttonLink
  buttonType
  buttonImage {
    ...AssetFields
  }
}
    `;
export const ArticleListFieldsFragmentDoc = gql`
    fragment ArticleListFields on ArticleList {
  sys {
    id
  }
  internalName
  title
  articleListDescriptionJson: description {
    json
  }
  articlesCollection(limit: $articleListLimit) {
    items {
      ...ArticleFields
    }
  }
  button {
    ...ButtonFields
  }
}
    `;
export const CardFieldInfoFragmentDoc = gql`
    fragment CardFieldInfo on Card {
  sys {
    id
  }
  cardTitle
  cardDescription {
    json
  }
}
    `;
export const CardFieldsFragmentDoc = gql`
    fragment CardFields on Card {
  sys {
    id
  }
  cardIcon {
    ...AssetFields
  }
  cardTitle
  cardDescription {
    json
  }
  subDescription {
    json
  }
  cardImage {
    ...AssetFields
  }
  cardBackgroundImage {
    ...AssetFields
  }
  cardLink
  cardLinkText
  cardEyebrowText
}
    `;
export const CardListFieldsFragmentDoc = gql`
    fragment CardListFields on CardList {
  sys {
    id
  }
  variant
  internalName
  eyebrowText
  title
  description
  cardsCollection {
    items {
      ...CardFields
    }
  }
}
    `;
export const HeroWithCardsFieldsFragmentDoc = gql`
    fragment HeroWithCardsFields on HeroWithCards {
  sys {
    id
  }
  internalName
  eyebrowText
  heroTitle
  heroDescriptionJson: description {
    json
  }
  buttonLink {
    ...ButtonFields
  }
  foregroundImage {
    ...AssetFields
  }
  backgroundImage {
    ...AssetFields
  }
  titleIcon {
    ...AssetFields
  }
  cardsCollection {
    items {
      ...CardFields
    }
  }
}
    `;
export const ImageAndTextFieldsFragmentDoc = gql`
    fragment ImageAndTextFields on ImageAndText {
  sys {
    id
  }
  internalName
  eyebrowText
  title
  imageDescriptionJson: description {
    json
  }
  buttonLink {
    ...ButtonFields
  }
  image {
    ...AssetFields
  }
  backgroundImage {
    ...AssetFields
  }
  videofile {
    ...AssetFields
  }
  additionalText
  variant
}
    `;
export const LogoFieldsFragmentDoc = gql`
    fragment LogoFields on Logo {
  sys {
    id
  }
  logoImage {
    url
    title
    imageDescriptionJson: description
  }
  logoName
  websiteUrl
  websiteUrlAltText
  openInNewWindow
}
    `;
export const LogoListFieldsFragmentDoc = gql`
    fragment LogoListFields on LogoList {
  sys {
    id
  }
  variant
  internalName
  eyebrowText
  title
  descriptionJson: description {
    json
  }
  logosCollection(limit: 15) {
    items {
      ...LogoFields
    }
  }
  logoListButton {
    ...ButtonFields
  }
}
    `;
export const TabFieldsFragmentDoc = gql`
    fragment TabFields on Tab {
  sys {
    id
  }
  colour
  tabTitle
  tabDescription {
    json
  }
  tabBackgroundImage {
    url
    title
    description
  }
  tabForegroundImage {
    url
    title
    description
  }
  tabSubDescription {
    json
  }
  infoItemsCollection(limit: $infoLimit) {
    items {
      ...AccordionItemFields
    }
  }
}
    `;
export const TabListFieldsFragmentDoc = gql`
    fragment TabListFields on TabList {
  sys {
    id
  }
  variant
  internalName
  eyebrowText
  title
  backgroundImage {
    url
    title
  }
  tabListdescriptionJson: description {
    json
  }
  linkButton {
    ...ButtonFields
  }
  tabsCollection {
    items {
      ...TabFields
    }
  }
}
    `;
export const AccordionIconItemFieldsFragmentDoc = gql`
    fragment AccordionIconItemFields on AccordionItem {
  sys {
    id
  }
  internalName
  itemText
  itemDescriptionJson: itemDescription {
    json
  }
  icon {
    ...AssetFields
  }
}
    `;
export const TabIconFieldsFragmentDoc = gql`
    fragment TabIconFields on Tab {
  sys {
    id
  }
  tabTitle
  tabDescription {
    json
  }
  tabForegroundImage {
    url
    title
    description
  }
  tabSubDescription {
    json
  }
  infoItemsCollection(limit: $infoLimit) {
    items {
      ...AccordionIconItemFields
    }
  }
}
    `;
export const TabListIconFieldsFragmentDoc = gql`
    fragment TabListIconFields on TabList {
  sys {
    id
  }
  internalName
  eyebrowText
  title
  tabListdescriptionJson: description {
    json
  }
  linkButton {
    ...ButtonFields
  }
  tabsCollection {
    items {
      ...TabIconFields
    }
  }
}
    `;
export const HeaderFieldsFragmentDoc = gql`
    fragment HeaderFields on Header {
  sys {
    id
  }
  internalName
  logoCollection(limit: $Limit) {
    items {
      ...LogoFields
    }
  }
  navigationLinksCollection(limit: $navigationLinksLimit) {
    items {
      ...LinkFields
    }
  }
  callToActionCollection(limit: $callToActionLimit) {
    items {
      ...ButtonFields
    }
  }
}
    `;
export const FooterFieldsFragmentDoc = gql`
    fragment FooterFields on Footer {
  sys {
    id
  }
  internalName
  logo {
    ...LogoFields
  }
  footerLinksCollection(limit: $linksLimit) {
    items {
      heading
      linksCollection {
        items {
          ...LinkFields
        }
      }
    }
  }
  copyrightText
  socialMediaLinksCollection(limit: $socialMediaLinksLimit) {
    items {
      ...LinkFields
    }
  }
}
    `;
export const MenuItemFieldsFragmentDoc = gql`
    fragment MenuItemFields on MenuItem {
  sys {
    id
  }
  title
  slug
  parentItem {
    sys {
      id
    }
  }
  orderposition
  openInNewTab
  linkText {
    ...LinkFields
  }
  description
  icon {
    ...AssetFields
  }
}
    `;
export const MenuFieldsFragmentDoc = gql`
    fragment MenuFields on Menu {
  sys {
    id
  }
  name
  menuItemsCollection {
    items {
      ...MenuItemFields
    }
  }
}
    `;
export const PageBlogDetailPageFieldsFragmentDoc = gql`
    fragment PageBlogDetailPageFields on PageBlogDetailPage {
  sys {
    id
  }
  slug
  internalName
  type
}
    `;
export const BlogSectionFieldsFragmentDoc = gql`
    fragment BlogSectionFields on BlogSection {
  sys {
    id
  }
  internalName
  type
}
    `;
export const ContentTileFieldsFragmentDoc = gql`
    fragment ContentTileFields on ContentTile {
  sys {
    id
  }
  title
  text {
    json
  }
  image {
    url
    description
  }
}
    `;
export const VerticalTabFieldsFragmentDoc = gql`
    fragment VerticalTabFields on VerticalTab {
  sys {
    id
  }
  eyeBrowText
  tabTitle
  featureCardTitle
  featureCardDescription
  featureCardImage {
    url
  }
  videoFile2 {
    url
  }
  videoFile3 {
    url
  }
  featureCardLinkText
  featureCardLinkUrl
  card2Title
  card2Description
  card2Image {
    url
  }
  card3Title
  card3Description
  card3Image {
    url
  }
  card4Title
  card4Description
  card4Image {
    url
  }
}
    `;
export const VerticalTabListFieldsFragmentDoc = gql`
    fragment VerticalTabListFields on VerticalTabList {
  sys {
    id
  }
  internalName
  eyebrowText
  title
  backgroundImage {
    ...AssetFields
  }
  verticaltabListdescriptionJson: description {
    json
  }
  linkButton {
    ...ButtonFields
  }
  verticalTabsCollection {
    items {
      ...VerticalTabFields
    }
  }
}
    `;
export const ImageAndTextFragmentFragmentDoc = gql`
    fragment ImageAndTextFragment on ImageAndText {
  sys {
    id
  }
  title
  eyebrowText
  buttonLink {
    ...ButtonFields
  }
  videofile {
    url
    title
  }
  image {
    url
    title
  }
  description {
    json
  }
  backgroundImage {
    ...AssetFields
  }
}
    `;
export const ImageAndTextListFragmentFragmentDoc = gql`
    fragment ImageAndTextListFragment on ImageAndTextList {
  sys {
    id
  }
  title
  eyebrowText
  imageAndTextListCollection {
    items {
      ...ImageAndTextFragment
    }
  }
}
    `;
export const ListOfLocationFragmentFragmentDoc = gql`
    fragment ListOfLocationFragment on ListOfLocation {
  sys {
    id
  }
  listOfLocationCollection {
    items {
      ... on LocationCard {
        sys {
          id
        }
        title
        information
        icon {
          ...LinkFields
        }
      }
    }
  }
}
    `;
export const SecurityTextFragmentFragmentDoc = gql`
    fragment SecurityTextFragment on SecurityText {
  title
  titleText {
    json
  }
  text {
    json
  }
  banner {
    url
    title
    description
  }
  sys {
    id
  }
}
    `;
export const HeroFieldsFragmentDoc = gql`
    fragment HeroFields on Hero {
  internalName
  sys {
    id
  }
  title
  heroFieldDescriptionJson: description {
    json
  }
  titleRtf
  heroImage {
    ...AssetFields
  }
  backgroundImage {
    ...AssetFields
  }
  primaryButton {
    ...ButtonFields
  }
  secondaryButton {
    ...ButtonFields
  }
}
    `;
export const SeoFieldsFragmentDoc = gql`
    fragment SEOFields on SeoFields {
  sys {
    id
  }
  internalName
  pageTitle
  pageDescription
  canonicalUrl
  nofollow
  noindex
  shareImagesCollection {
    items {
      sys {
        id
      }
      url
      fileName
      description
    }
  }
}
    `;
export const AdobeSummitFragmentFragmentDoc = gql`
    fragment AdobeSummitFragment on AdobeSummit {
  title
  description {
    json
  }
  banner {
    ...HeroFields
  }
  primaryButton {
    ...ButtonFields
  }
  cardCollection {
    items {
      ...CardFields
    }
  }
  seoFields {
    ...SEOFields
  }
  sys {
    id
  }
}
    `;
export const BannerFragmentFragmentDoc = gql`
    fragment BannerFragment on Banner {
  sys {
    id
  }
  title
  link {
    ...LinkFields
  }
  icon {
    url
    title
  }
}
    `;
export const TagsFieldsFragmentDoc = gql`
    fragment TagsFields on Tags {
  title
}
    `;
export const ProfileFieldsFragmentDoc = gql`
    fragment ProfileFields on Profile {
  image {
    sys {
      id
    }
    url
    title
  }
  logo {
    sys {
      id
    }
    url
    title
  }
  title
  position
  tagsCollection(limit: 10) {
    items {
      sys {
        id
      }
      ...TagsFields
    }
  }
}
    `;
export const ProfilleDataFieldsFragmentDoc = gql`
    fragment ProfilleDataFields on ProfilleData {
  title
  description
  profileCollection(limit: 20) {
    items {
      sys {
        id
      }
      ...ProfileFields
    }
  }
}
    `;
export const GetBatchContentOneDocument = gql`
    query GetBatchContentOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetBatchContentTwoDocument = gql`
    query GetBatchContentTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 15) {
      items {
        sys {
          id
        }
        __typename
        ... on LogoList {
          ...LogoListFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}`;
export const GetBatchContentThreeDocument = gql`
    query GetBatchContentThree($id: String!, $infoLimit: Int = 3, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on TabList {
          ...TabListFields
        }
        ... on Accordion {
          ...AccordionFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${AccordionFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPageBatchBySlugDocument = gql`
    query GetPageBatchBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetBlogDetailPageDocument = gql`
    query GetBlogDetailPage($slug: String!) {
  pageBlogDetailPageCollection(where: {slug: $slug}, limit: 1) {
    items {
      internalName
      seoFields {
        ...SEOFields
      }
      slug
      blog {
        ...ArticleFields
      }
    }
  }
}
    ${SeoFieldsFragmentDoc}
${ArticleFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AuthorFieldsFragmentDoc}
${ListOfLinksFieldsFragmentDoc}`;
export const GetBlogDetailsSlugsDocument = gql`
    query GetBlogDetailsSlugs {
  pageBlogDetailPageCollection {
    items {
      sys {
        id
      }
      slug
    }
  }
}
    `;
export const GetAssetDetailsDocument = gql`
    query GetAssetDetails($id: String!) {
  asset(id: $id) {
    url
    fileName
    description
  }
}
    `;
export const GetBlogPageDocument = gql`
    query GetBlogPage($id: String!) {
  blogSection(id: $id) {
    internalName
    sys {
      id
    }
    seoFields {
      ...SEOFields
    }
    eyebrowText
    title
    backgroundImage {
      url
      title
    }
    featuredBlog {
      ...ArticleFields
    }
  }
}
    ${SeoFieldsFragmentDoc}
${ArticleFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AuthorFieldsFragmentDoc}
${ListOfLinksFieldsFragmentDoc}`;
export const GetBlogSectionIDsDocument = gql`
    query GetBlogSectionIDs {
  blogSectionCollection {
    items {
      sys {
        id
      }
      title
    }
  }
}
    `;
export const GetDesktopOneDocument = gql`
    query GetDesktopOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetDesktopTwoDocument = gql`
    query GetDesktopTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 15) {
      items {
        sys {
          id
        }
        __typename
        ... on LogoList {
          ...LogoListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}`;
export const GetDesktopThreeDocument = gql`
    query GetDesktopThree($id: String!, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Accordion {
          ...AccordionFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${AccordionFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPageDesktopBySlugDocument = gql`
    query GetPageDesktopBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetEnterprisePageOneDocument = gql`
    query GetEnterprisePageOne($id: String!, $infoLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on TabList {
          ...TabListIconFields
        }
        ... on CardList {
          ...CardListFields
        }
        ... on ImageAndText {
          ...ImageAndTextFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabListIconFieldsFragmentDoc}
${TabIconFieldsFragmentDoc}
${AccordionIconItemFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetEnterprisePageTwoDocument = gql`
    query GetEnterprisePageTwo($id: String!, $accordionItemLimit: Int = 5, $infoLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Accordion {
          ...AccordionFields
        }
        ... on AccordionItem {
          ...AccordionItemFields
        }
        ... on VerticalTabList {
          ...VerticalTabListFields
        }
        ... on TabList {
          ...TabListFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${AccordionFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${VerticalTabListFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${VerticalTabFieldsFragmentDoc}
${TabListFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPageEnterpriseBySlugDocument = gql`
    query GetPageEnterpriseBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetEventLandingOneDocument = gql`
    query GetEventLandingOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on VerticalTabList {
          ...VerticalTabListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${VerticalTabListFieldsFragmentDoc}
${VerticalTabFieldsFragmentDoc}`;
export const GetEventLandingTwoDocument = gql`
    query GetEventLandingTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 10) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}`;
export const GetEventLandingThreeDocument = gql`
    query GetEventLandingThree($id: String!, $infoLimit: Int = 3) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on TabList {
          ...TabListFields
        }
        ... on ProfilleData {
          ...ProfilleDataFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${ProfilleDataFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${TagsFieldsFragmentDoc}`;
export const GetPageSiteBySlugDocument = gql`
    query GetPageSiteBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetTextPageDocument = gql`
    query GetTextPage($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on SecurityText {
          ...SecurityTextFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${SecurityTextFragmentFragmentDoc}`;
export const GetPageBySlugDocument = gql`
    query GetPageBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetIndustryPageOneDocument = gql`
    query GetIndustryPageOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetIndustryPageTwoDocument = gql`
    query GetIndustryPageTwo($id: String!, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Accordion {
          ...AccordionFields
        }
        ... on AccordionItem {
          ...AccordionItemFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${AccordionFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetHomePageBasicComponentsDocument = gql`
    query GetHomePageBasicComponents($componentsLimit: Int = 10, $internalName: String, $skip: Int = 0) {
  pageGenericCollection(where: {internalName: $internalName}, limit: 1) {
    items {
      internalName
      sys {
        id
      }
      componentsCollection(limit: $componentsLimit, skip: $skip) {
        items {
          __typename
          ... on Hero {
            ...HeroFields
          }
          ... on ContentTile {
            ...ContentTileFields
          }
          ... on LogoList {
            ...LogoListFields
          }
        }
      }
    }
  }
}
    ${HeroFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${ContentTileFieldsFragmentDoc}
${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}`;
export const GetHomePageListComponentsDocument = gql`
    query GetHomePageListComponents($componentsLimit: Int = 5, $articleListLimit: Int = 4, $internalName: String, $skip: Int = 0) {
  pageGenericCollection(where: {internalName: $internalName}, limit: 1) {
    items {
      sys {
        id
      }
      componentsCollection(limit: $componentsLimit, skip: $skip) {
        items {
          __typename
          ... on ImageAndText {
            ...ImageAndTextFields
          }
          ... on HeroWithCards {
            ...HeroWithCardsFields
          }
          ... on ArticleList {
            ...ArticleListFields
          }
        }
      }
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${HeroWithCardsFieldsFragmentDoc}
${CardFieldsFragmentDoc}
${ArticleListFieldsFragmentDoc}
${ArticleFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AuthorFieldsFragmentDoc}
${ListOfLinksFieldsFragmentDoc}`;
export const GetHomePageNavComponentsDocument = gql`
    query GetHomePageNavComponents($componentsLimit: Int = 5, $infoLimit: Int = 5, $internalName: String, $skip: Int = 0) {
  pageGenericCollection(where: {internalName: $internalName}, limit: 1) {
    items {
      sys {
        id
      }
      componentsCollection(limit: $componentsLimit, skip: $skip) {
        items {
          __typename
          ... on TabList {
            ...TabListFields
          }
          ... on VerticalTabList {
            ...VerticalTabListFields
          }
        }
      }
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${VerticalTabListFieldsFragmentDoc}
${VerticalTabFieldsFragmentDoc}`;
export const GetHomePageCardComponentsDocument = gql`
    query GetHomePageCardComponents($componentsLimit: Int = 5, $accordionItemLimit: Int = 3, $internalName: String, $skip: Int = 0) {
  pageGenericCollection(where: {internalName: $internalName}, limit: 1) {
    items {
      sys {
        id
      }
      componentsCollection(limit: $componentsLimit, skip: $skip) {
        items {
          __typename
          ... on CardList {
            ...CardListFields
          }
          ... on Accordion {
            ...AccordionFields
          }
        }
      }
    }
  }
}
    ${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${AccordionFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}`;
export const GetHomePageSeoDocument = gql`
    query GetHomePageSEO($internalName: String) {
  pageGenericCollection(where: {internalName: $internalName}, limit: 10) {
    items {
      sys {
        id
      }
      componentsCollection(limit: 15) {
        items {
          __typename
          ... on SeoFields {
            ...SEOFields
          }
        }
      }
    }
  }
}
    ${SeoFieldsFragmentDoc}`;
export const GetLayoutComponentsDocument = gql`
    query GetLayoutComponents($componentsLimit: Int = 10, $navigationLinksLimit: Int = 10, $callToActionLimit: Int = 10, $linksLimit: Int = 10, $socialMediaLinksLimit: Int = 10, $Limit: Int = 20) {
  layoutComponentsCollection(limit: 1) {
    items {
      internalName
      componentsCollection(limit: $componentsLimit) {
        items {
          __typename
          ... on Header {
            ...HeaderFields
          }
          ... on Footer {
            ...FooterFields
          }
          ... on ImageAndText {
            ...ImageAndTextFields
          }
          ... on Banner {
            ...BannerFragment
          }
        }
      }
    }
  }
}
    ${HeaderFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${FooterFieldsFragmentDoc}
${ImageAndTextFieldsFragmentDoc}
${BannerFragmentFragmentDoc}`;
export const GetMenuIdDocument = gql`
    query GetMenuId {
  menuCollection {
    items {
      sys {
        id
      }
      name
    }
  }
}
    `;
export const GetMenuDocument = gql`
    query GetMenu($menuId: String!) {
  menu(id: $menuId) {
    sys {
      id
    }
    name
    menuItemsCollection(limit: 10) {
      items {
        ...MenuItemFields
      }
    }
  }
}
    ${MenuItemFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AssetFieldsFragmentDoc}`;
export const GetMenuItemsDocument = gql`
    query GetMenuItems {
  menuItemCollection {
    items {
      ...MenuItemFields
    }
  }
}
    ${MenuItemFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AssetFieldsFragmentDoc}`;
export const GetSubMenuItemsDocument = gql`
    query GetSubMenuItems {
  menuItemCollection(where: {parentItem_exists: true}) {
    items {
      ...MenuItemFields
    }
  }
}
    ${MenuItemFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AssetFieldsFragmentDoc}`;
export const GetOmniChannelOneDocument = gql`
    query GetOmniChannelOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetOmniChannelTwoDocument = gql`
    query GetOmniChannelTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 15) {
      items {
        sys {
          id
        }
        __typename
        ... on LogoList {
          ...LogoListFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}`;
export const GetOmniChannelThreeDocument = gql`
    query GetOmniChannelThree($id: String!, $infoLimit: Int = 3, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on TabList {
          ...TabListFields
        }
        ... on Accordion {
          ...AccordionFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${AccordionFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPageOmniBySlugDocument = gql`
    query GetPageOmniBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetPartnerPageOneDocument = gql`
    query GetPartnerPageOne($id: String!, $infoLimit: Int = 5, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Hero {
          ...HeroFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
        ... on TabList {
          ...TabListFields
        }
        ... on Accordion {
          ...AccordionFields
        }
        ... on LogoList {
          ...LogoListFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${HeroFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}
${TabListFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${AccordionFieldsFragmentDoc}
${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPagePartnerBySlugDocument = gql`
    query GetPagePartnerBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetProductPageOneDocument = gql`
    query GetProductPageOne($id: String!, $infoLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on TabList {
          ...TabListIconFields
        }
        ... on CardList {
          ...CardListFields
        }
        ... on ImageAndText {
          ...ImageAndTextFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabListIconFieldsFragmentDoc}
${TabIconFieldsFragmentDoc}
${AccordionIconItemFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetProductPageTwoDocument = gql`
    query GetProductPageTwo($id: String!, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Accordion {
          ...AccordionFields
        }
        ... on AccordionItem {
          ...AccordionItemFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${AccordionFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPageProductBySlugDocument = gql`
    query GetPageProductBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetSiteScoreOneDocument = gql`
    query GetSiteScoreOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetSiteScoreTwoDocument = gql`
    query GetSiteScoreTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 10) {
      items {
        sys {
          id
        }
        __typename
        ... on LogoList {
          ...LogoListFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}`;
export const GetSiteScoreThreeDocument = gql`
    query GetSiteScoreThree($id: String!, $infoLimit: Int = 3) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on TabList {
          ...TabListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}`;
export const GetPageSummitBySlugDocument = gql`
    query GetPageSummitBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetSummitPageDocument = gql`
    query GetSummitPage($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on Hero {
          ...HeroFields
        }
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on ListOfLocation {
          ...ListOfLocationFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${HeroFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${ImageAndTextFieldsFragmentDoc}
${ListOfLocationFragmentFragmentDoc}
${LinkFieldsFragmentDoc}`;
export const GetAdobePageDocument = gql`
    query GetAdobePage($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on AdobeSummit {
          ...AdobeSummitFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${AdobeSummitFragmentFragmentDoc}
${HeroFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${CardFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetTaskInitiationtOneDocument = gql`
    query GetTaskInitiationtOne($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on ImageAndText {
          ...ImageAndTextFields
        }
        ... on CardList {
          ...CardListFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${ImageAndTextFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${CardListFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const GetTaskInitiationtTwoDocument = gql`
    query GetTaskInitiationtTwo($id: String!) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 15) {
      items {
        sys {
          id
        }
        __typename
        ... on LogoList {
          ...LogoListFields
        }
        ... on ImageAndTextList {
          ...ImageAndTextListFragment
        }
      }
    }
    sys {
      id
    }
  }
}
    ${LogoListFieldsFragmentDoc}
${LogoFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${ImageAndTextListFragmentFragmentDoc}
${ImageAndTextFragmentFragmentDoc}`;
export const GetTaskInitiationtThreeDocument = gql`
    query GetTaskInitiationtThree($id: String!, $infoLimit: Int = 3, $accordionItemLimit: Int = 5) {
  pageGeneric(id: $id) {
    internalName
    componentsCollection(limit: 8) {
      items {
        sys {
          id
        }
        __typename
        ... on TabList {
          ...TabListFields
        }
        ... on Accordion {
          ...AccordionFields
        }
        ... on SeoFields {
          ...SEOFields
        }
      }
    }
    sys {
      id
    }
  }
}
    ${TabListFieldsFragmentDoc}
${ButtonFieldsFragmentDoc}
${AssetFieldsFragmentDoc}
${TabFieldsFragmentDoc}
${AccordionItemFieldsFragmentDoc}
${AccordionFieldsFragmentDoc}
${SeoFieldsFragmentDoc}`;
export const GetPagetaskBySlugDocument = gql`
    query GetPagetaskBySlug($slug: String!) {
  pageGenericCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      slug
      internalName
    }
  }
}
    `;
export const GetAuthorDetailsDocument = gql`
    query GetAuthorDetails($id: String!) {
  author(id: $id) {
    ...AuthorFields
  }
}
    ${AuthorFieldsFragmentDoc}`;
export const GetArticlesDocument = gql`
    query GetArticles($limit: Int, $skip: Int) {
  articleCollection(limit: $limit, skip: $skip, order: publicationDate_DESC) {
    items {
      ...ArticleFields
    }
  }
}
    ${ArticleFieldsFragmentDoc}
${LinkFieldsFragmentDoc}
${AuthorFieldsFragmentDoc}
${ListOfLinksFieldsFragmentDoc}`;
export const GetContentTileDocument = gql`
    query GetContentTile {
  contentTileCollection {
    items {
      ...ContentTileFields
    }
  }
}
    ${ContentTileFieldsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetBatchContentOne(variables: GetBatchContentOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBatchContentOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBatchContentOneQuery>(GetBatchContentOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBatchContentOne', 'query', variables);
    },
    GetBatchContentTwo(variables: GetBatchContentTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBatchContentTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBatchContentTwoQuery>(GetBatchContentTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBatchContentTwo', 'query', variables);
    },
    GetBatchContentThree(variables: GetBatchContentThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBatchContentThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBatchContentThreeQuery>(GetBatchContentThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBatchContentThree', 'query', variables);
    },
    GetPageBatchBySlug(variables: GetPageBatchBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageBatchBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageBatchBySlugQuery>(GetPageBatchBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageBatchBySlug', 'query', variables);
    },
    GetBlogDetailPage(variables: GetBlogDetailPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogDetailPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogDetailPageQuery>(GetBlogDetailPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogDetailPage', 'query', variables);
    },
    GetBlogDetailsSlugs(variables?: GetBlogDetailsSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogDetailsSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogDetailsSlugsQuery>(GetBlogDetailsSlugsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogDetailsSlugs', 'query', variables);
    },
    GetAssetDetails(variables: GetAssetDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAssetDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAssetDetailsQuery>(GetAssetDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAssetDetails', 'query', variables);
    },
    GetBlogPage(variables: GetBlogPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPageQuery>(GetBlogPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogPage', 'query', variables);
    },
    GetBlogSectionIDs(variables?: GetBlogSectionIDsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogSectionIDsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogSectionIDsQuery>(GetBlogSectionIDsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogSectionIDs', 'query', variables);
    },
    GetDesktopOne(variables: GetDesktopOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDesktopOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesktopOneQuery>(GetDesktopOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDesktopOne', 'query', variables);
    },
    GetDesktopTwo(variables: GetDesktopTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDesktopTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesktopTwoQuery>(GetDesktopTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDesktopTwo', 'query', variables);
    },
    GetDesktopThree(variables: GetDesktopThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDesktopThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesktopThreeQuery>(GetDesktopThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDesktopThree', 'query', variables);
    },
    GetPageDesktopBySlug(variables: GetPageDesktopBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageDesktopBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageDesktopBySlugQuery>(GetPageDesktopBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageDesktopBySlug', 'query', variables);
    },
    GetEnterprisePageOne(variables: GetEnterprisePageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEnterprisePageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEnterprisePageOneQuery>(GetEnterprisePageOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEnterprisePageOne', 'query', variables);
    },
    GetEnterprisePageTwo(variables: GetEnterprisePageTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEnterprisePageTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEnterprisePageTwoQuery>(GetEnterprisePageTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEnterprisePageTwo', 'query', variables);
    },
    GetPageEnterpriseBySlug(variables: GetPageEnterpriseBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageEnterpriseBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageEnterpriseBySlugQuery>(GetPageEnterpriseBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageEnterpriseBySlug', 'query', variables);
    },
    GetEventLandingOne(variables: GetEventLandingOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEventLandingOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventLandingOneQuery>(GetEventLandingOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEventLandingOne', 'query', variables);
    },
    GetEventLandingTwo(variables: GetEventLandingTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEventLandingTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventLandingTwoQuery>(GetEventLandingTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEventLandingTwo', 'query', variables);
    },
    GetEventLandingThree(variables: GetEventLandingThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEventLandingThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventLandingThreeQuery>(GetEventLandingThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEventLandingThree', 'query', variables);
    },
    GetPageSiteBySlug(variables: GetPageSiteBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageSiteBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSiteBySlugQuery>(GetPageSiteBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageSiteBySlug', 'query', variables);
    },
    GetTextPage(variables: GetTextPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTextPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTextPageQuery>(GetTextPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTextPage', 'query', variables);
    },
    GetPageBySlug(variables: GetPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageBySlugQuery>(GetPageBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageBySlug', 'query', variables);
    },
    GetIndustryPageOne(variables: GetIndustryPageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetIndustryPageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIndustryPageOneQuery>(GetIndustryPageOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetIndustryPageOne', 'query', variables);
    },
    GetIndustryPageTwo(variables: GetIndustryPageTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetIndustryPageTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIndustryPageTwoQuery>(GetIndustryPageTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetIndustryPageTwo', 'query', variables);
    },
    GetHomePageBasicComponents(variables?: GetHomePageBasicComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHomePageBasicComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageBasicComponentsQuery>(GetHomePageBasicComponentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetHomePageBasicComponents', 'query', variables);
    },
    GetHomePageListComponents(variables?: GetHomePageListComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHomePageListComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageListComponentsQuery>(GetHomePageListComponentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetHomePageListComponents', 'query', variables);
    },
    GetHomePageNavComponents(variables?: GetHomePageNavComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHomePageNavComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageNavComponentsQuery>(GetHomePageNavComponentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetHomePageNavComponents', 'query', variables);
    },
    GetHomePageCardComponents(variables?: GetHomePageCardComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHomePageCardComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageCardComponentsQuery>(GetHomePageCardComponentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetHomePageCardComponents', 'query', variables);
    },
    GetHomePageSEO(variables?: GetHomePageSeoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHomePageSeoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageSeoQuery>(GetHomePageSeoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetHomePageSEO', 'query', variables);
    },
    GetLayoutComponents(variables?: GetLayoutComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLayoutComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLayoutComponentsQuery>(GetLayoutComponentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLayoutComponents', 'query', variables);
    },
    GetMenuId(variables?: GetMenuIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMenuIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMenuIdQuery>(GetMenuIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMenuId', 'query', variables);
    },
    GetMenu(variables: GetMenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMenuQuery>(GetMenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMenu', 'query', variables);
    },
    GetMenuItems(variables?: GetMenuItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMenuItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMenuItemsQuery>(GetMenuItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMenuItems', 'query', variables);
    },
    GetSubMenuItems(variables?: GetSubMenuItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubMenuItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubMenuItemsQuery>(GetSubMenuItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubMenuItems', 'query', variables);
    },
    GetOmniChannelOne(variables: GetOmniChannelOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOmniChannelOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOmniChannelOneQuery>(GetOmniChannelOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOmniChannelOne', 'query', variables);
    },
    GetOmniChannelTwo(variables: GetOmniChannelTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOmniChannelTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOmniChannelTwoQuery>(GetOmniChannelTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOmniChannelTwo', 'query', variables);
    },
    GetOmniChannelThree(variables: GetOmniChannelThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOmniChannelThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOmniChannelThreeQuery>(GetOmniChannelThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOmniChannelThree', 'query', variables);
    },
    GetPageOmniBySlug(variables: GetPageOmniBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageOmniBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageOmniBySlugQuery>(GetPageOmniBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageOmniBySlug', 'query', variables);
    },
    GetPartnerPageOne(variables: GetPartnerPageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPartnerPageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerPageOneQuery>(GetPartnerPageOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPartnerPageOne', 'query', variables);
    },
    GetPagePartnerBySlug(variables: GetPagePartnerBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPagePartnerBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPagePartnerBySlugQuery>(GetPagePartnerBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPagePartnerBySlug', 'query', variables);
    },
    GetProductPageOne(variables: GetProductPageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductPageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductPageOneQuery>(GetProductPageOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductPageOne', 'query', variables);
    },
    GetProductPageTwo(variables: GetProductPageTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductPageTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductPageTwoQuery>(GetProductPageTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductPageTwo', 'query', variables);
    },
    GetPageProductBySlug(variables: GetPageProductBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageProductBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageProductBySlugQuery>(GetPageProductBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageProductBySlug', 'query', variables);
    },
    GetSiteScoreOne(variables: GetSiteScoreOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteScoreOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteScoreOneQuery>(GetSiteScoreOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSiteScoreOne', 'query', variables);
    },
    GetSiteScoreTwo(variables: GetSiteScoreTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteScoreTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteScoreTwoQuery>(GetSiteScoreTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSiteScoreTwo', 'query', variables);
    },
    GetSiteScoreThree(variables: GetSiteScoreThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteScoreThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteScoreThreeQuery>(GetSiteScoreThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSiteScoreThree', 'query', variables);
    },
    GetPageSummitBySlug(variables: GetPageSummitBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageSummitBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSummitBySlugQuery>(GetPageSummitBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageSummitBySlug', 'query', variables);
    },
    GetSummitPage(variables: GetSummitPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSummitPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSummitPageQuery>(GetSummitPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSummitPage', 'query', variables);
    },
    GetAdobePage(variables: GetAdobePageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAdobePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAdobePageQuery>(GetAdobePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAdobePage', 'query', variables);
    },
    GetTaskInitiationtOne(variables: GetTaskInitiationtOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTaskInitiationtOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTaskInitiationtOneQuery>(GetTaskInitiationtOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTaskInitiationtOne', 'query', variables);
    },
    GetTaskInitiationtTwo(variables: GetTaskInitiationtTwoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTaskInitiationtTwoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTaskInitiationtTwoQuery>(GetTaskInitiationtTwoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTaskInitiationtTwo', 'query', variables);
    },
    GetTaskInitiationtThree(variables: GetTaskInitiationtThreeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTaskInitiationtThreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTaskInitiationtThreeQuery>(GetTaskInitiationtThreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTaskInitiationtThree', 'query', variables);
    },
    GetPagetaskBySlug(variables: GetPagetaskBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPagetaskBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPagetaskBySlugQuery>(GetPagetaskBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPagetaskBySlug', 'query', variables);
    },
    GetAuthorDetails(variables: GetAuthorDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAuthorDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAuthorDetailsQuery>(GetAuthorDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAuthorDetails', 'query', variables);
    },
    GetArticles(variables?: GetArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArticlesQuery>(GetArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetArticles', 'query', variables);
    },
    GetContentTile(variables?: GetContentTileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetContentTileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContentTileQuery>(GetContentTileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetContentTile', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;